// ================================
// Version: 1.0.1
// ================================
// Universal Scripting
// ================================
// ================================
// Media
// ================================

// Custom video button - scoped to closest video in the same parent element
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.rev-play');
  if (!btn) return;
  const wrap = btn.closest('.rev-media');
  if (!wrap) return;
  const video = wrap.querySelector('video');
  if (!video) return;
  if (!video.hasAttribute('controls')) video.setAttribute('controls', 'controls');
  try { video.muted = false; } catch (_) { }
  const p = video.play();
  if (p && typeof p.catch === 'function') p.catch(() => { /* ignore autoplay-policy errors */ });
  btn.style.display = 'none';
  video.addEventListener('ended', function handleEnd() {
    video.removeAttribute('controls');
    btn.hidden = false;
    video.currentTime = 0;
    video.pause();
    video.removeEventListener('ended', handleEnd);
  }, { once: true });
}, { passive: true });

// ================================
// Arrives By Date Calculator
// ================================
function updateArrivesByDates() {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

  function formatDate(date) {
    const d = new Date(date);
    return monthNames[d.getMonth()] + ' ' + d.getDate();
  }

  document.querySelectorAll('.rev-arrives-by[data-arrives-by-days-delivery]').forEach(el => {
    const daysDelivery = parseInt(el.dataset.arrivesByDaysDelivery, 10);
    const daysLatest = parseInt(el.dataset.arrivesByDaysLatest, 10);

    const dateEst = new Date();
    dateEst.setDate(dateEst.getDate() + daysDelivery);

    const dateLatest = new Date();
    dateLatest.setDate(dateLatest.getDate() + daysLatest);

    el.querySelector('.rev-arrives-date-est').textContent = formatDate(dateEst);
    el.querySelector('.rev-arrives-date-latest').textContent = formatDate(dateLatest);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateArrivesByDates);
} else {
  updateArrivesByDates();
}

// ================================
// Generic Partial Rerender
// Can rerender anything as long as:
// - server HTML contains the same selectors
// - caller provides a URL
// ================================

const RevRerender = (() => {
  const abortMap = new WeakMap();

  async function rerender({
    contextEl,
    targets = [],
    url,
    params = {},
    incomingScopeSelector = null,
  }) {
    if (!contextEl || !targets.length) return;

    const controller = new AbortController();
    abortMap.get(contextEl)?.abort();
    abortMap.set(contextEl, controller);

    const finalUrl = buildUrl(url, params);
    if (!finalUrl) return;

    const res = await fetch(finalUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: controller.signal
    });
    if (!res.ok) return;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const incomingRoot = incomingScopeSelector
      ? doc.querySelector(incomingScopeSelector)
      : doc;

    if (!incomingRoot) return;

    targets.forEach(selector => {
      const current = contextEl.querySelector(selector);
      if (!current) return;

      const incoming = incomingRoot.querySelector(selector);
      if (!incoming) return;

      current.replaceWith(incoming);
    });
  }

  function buildUrl(url, params) {
    if (!url) return null;

    if (typeof url === 'function') return url(params);

    const u = new URL(url, window.location.origin);
    Object.entries(params).forEach(([k, v]) => {
      if (v != null) u.searchParams.set(k, v);
    });
    return u.toString();
  }

  return { rerender };
})();

// ================================
// Client-Side Variant Updates
// Handles component updates without server rerender
// ================================

const RevClientUpdate = (() => {
  function price(contextEl, variant, parentSelector = '') {
    if (!contextEl || !variant) return;
    const selector = parentSelector ? `${parentSelector} .rev-price-wrapper` : '.rev-price-wrapper';
    const wrapper = contextEl.querySelector(selector);
    if (!wrapper) return;
    const cfgScript = wrapper.querySelector('script.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent);
    } catch (e) {
      return;
    }
    const variantData = cfg.variants.find(v => v.id === variant.id);
    if (!variantData) return;
    const priceValue = wrapper.querySelector('.rev-price-value');
    if (priceValue) {
      priceValue.textContent = variantData.price;
      priceValue.classList.toggle('rev-price-sale', variantData.slash);
    }
    const slashEl = wrapper.querySelector('.rev-price-slash');
    if (slashEl) {
      slashEl.textContent = variantData.compare_at;
      slashEl.style.display = variantData.slash ? '' : 'none';
    }
    const savingsEl = wrapper.querySelector('.rev-savings');
    if (savingsEl) {
      savingsEl.style.display = variantData.slash ? '' : 'none';
      savingsEl.textContent = variantData.saving;
    }
  }

  function inventory(contextEl, variant, parentSelector = '') {
    if (!contextEl || !variant) return;
    const selector = parentSelector ? `${parentSelector} .rev-inventory` : '.rev-inventory';
    const wrapper = contextEl.querySelector(selector);
    if (!wrapper) return;
    const cfgScript = wrapper.querySelector('script.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent);
    } catch (e) {
      return;
    }
    const variantData = cfg.variants.find(v => v.id === variant.id);
    if (!variantData) return;
    const allStatuses = ['in-stock', 'med', 'low', 'preorder', 'oos'];
    allStatuses.forEach(s => wrapper.classList.remove(`rev-inventory-${s}`));
    wrapper.classList.add(`rev-inventory-${variantData.status}`);
    const textEl = wrapper.querySelector('.rev-inventory-text');
    if (textEl) textEl.textContent = variantData.text;
    const progressBar = wrapper.querySelector('.rev-inventory-bar');
    if (progressBar) {
      progressBar.value = variantData.qty;
      progressBar.textContent = variantData.qty;
    }
  }

  function klaviyoBis(contextEl, variant) {
    if (!contextEl || !variant) return;
    const wrapper = contextEl.querySelector('.rev-kl-bis');
    if (!wrapper) return;
    const cfgScript = wrapper.querySelector('script.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent);
    } catch (e) {
      return;
    }
    const variantData = cfg.variants.find(v => v.id === variant.id);
    if (!variantData) return;
    const trigger = wrapper.querySelector('.klaviyo-bis-trigger');
    if (!trigger) return;
    trigger.dataset.variant = variant.id;
    if (variantData.show) {
      trigger.style.setProperty('display', 'block', 'important');
    } else {
      trigger.style.setProperty('display', 'none', 'important');
    }
  }

  function buyButtons(contextEl, variant, parentSelector = '') {
    if (!contextEl) return;
    const selector = parentSelector ? `${parentSelector} .rev-buy-buttons` : '.rev-buy-buttons';
    const wrapper = contextEl.querySelector(selector);
    if (!wrapper) return;
    const cfgScript = wrapper.querySelector('script.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent);
    } catch (e) {
      return;
    }
    const variantData = cfg.variants.find(v => v.id === variant.id);
    if (!variantData) return;
    const status = variantData.status;
    const label = variantData.label;
    const button = wrapper.querySelector('.rev-atc-button');
    if (button) {
      const labelSpan = button.querySelector('span');
      if (labelSpan) {
        labelSpan.textContent = label;
      }
      button.setAttribute('aria-label', label);
      button.classList.remove('rev-button-status-atc', 'rev-button-status-preorder', 'rev-button-status-oos');
      button.classList.add(`rev-button-status-${status}`);
      button.disabled = (status === 'oos');
      button.classList.toggle('rev-button-oos', status === 'oos');
      button.dataset.variantId = variant.id;
    }
    const dynamicCheckout = wrapper.querySelector('.rev-dynamic-checkout');
    if (dynamicCheckout) {
      dynamicCheckout.style.display = (status === 'oos') ? 'none' : '';
    }
    const preorderText = wrapper.querySelector('.rev-preorder-text');
    if (preorderText) {
      preorderText.style.display = (status === 'preorder') ? '' : 'none';
    }
  }

  function gallery(contextEl, variant) {
    if (!contextEl || !variant) return;
    const galleryEl = contextEl.querySelector('.rev-product-gallery');
    if (!galleryEl) return;
    const cfgScript = galleryEl.querySelector('.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent);
    } catch (e) {
      return;
    }
    const variantData = cfg.variants.find(v => v.id === variant.id);
    if (!variantData || !variantData.media) return;
    const playButtonSvg = `<span class="rev-play-button"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" class="rev-icon rev-icon-play" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12L6 22.3923L6 1.60769L24 12Z" fill="currentColor"/></svg></span>`;
    const thumbnails = galleryEl.querySelector('.rev-gallery-thumbnails');
    if (thumbnails) {
      thumbnails.innerHTML = variantData.media.map((m, i) => `
        <div class="rev-gallery-thumbnail-item rev-media${i === 0 ? ' rev-gallery-thumbnail-active' : ''}" data-index="${i}" data-media-id="${m.id}">
          ${m.type === 'video' ? playButtonSvg : ''}
          ${m.thumbnail}
        </div>
      `).join('');
    }
    const track = galleryEl.querySelector('.rev-gallery-track');
    if (track) {
      track.innerHTML = variantData.media.map((m, i) => `
        <div class="rev-media" data-index="${i}" data-media-id="${m.id}">
          ${m.main}
          ${m.type === 'video' ? `<button type="button" class="rev-play" aria-label="Play video">${playButtonSvg}</button>` : ''}
        </div>
      `).join('');
    }
    const bulletContainer = galleryEl.querySelector('.rev-gallery-slide-indicator');
    if (bulletContainer) {
      bulletContainer.innerHTML = variantData.media.map((m, i) => `
        <button type="button" class="rev-gallery-slide-bullet${i === 0 ? ' rev-gallery-slide-bullet-active' : ''}" data-index="${i}" data-media-id="${m.id}" aria-label="Go to slide ${i + 1}"></button>
      `).join('');
    }
    // Reset gallery initialization, including zoom if present
    galleryEl.removeAttribute('data-rev-gallery-init');
    galleryEl.removeAttribute('data-rev-zoom-init');
    galleryEl._revGalleryInstance = null;
    if (window.RevGallery?.init) {
      window.RevGallery.init(galleryEl);
    }
    if (window.RevGalleryZoom?.init) {
      const wrapper = galleryEl.closest('.rev-product-gallery-wrapper') || galleryEl.closest('[data-section-id]') || galleryEl.parentElement;
      if (wrapper) window.RevGalleryZoom.init(wrapper);
    }
  }
  return { price, inventory, klaviyoBis, buyButtons, gallery };
})();
window.RevClientUpdate = RevClientUpdate;

// ================================
// Variant Selector
// ================================

// Pageload Triggers: Product Page URL Variant Parameter Set and disable invalid variant options
document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('.rev-product-main');
  if (!main) return;
  if (!window.location.pathname.includes('/products/')) return;

  const form = main.querySelector('form.rev-product-form');
  const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
  const variantId = idInput?.value;
  if (!variantId) return;

  const url = new URL(window.location.href);
  if (!url.searchParams.get('variant')) {
    url.searchParams.set('variant', String(variantId));
    window.history.replaceState({}, '', url.toString());
  }

  initVariantSelectorState(document);
  // Trigger gallery autoscroll
  const selectorEl = main.querySelector('.rev-variant-selector[data-context="main"]');
  const cfgScript = selectorEl?.querySelector('.rev-cfg');
  if (cfgScript) {
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent.trim());
    } catch (e) {
      return;
    }
    const variant = cfg.variants.find(v => v.id === parseInt(variantId, 10));
    if (variant?.feat_media) {
      setTimeout(() => {
        const gallery = main.querySelector('.rev-product-gallery');
        if (!gallery) return;

        const targetMediaId = variant.feat_media.toString();
        const mediaElements = gallery.querySelectorAll('[data-media-id]');

        let targetIndex = -1;
        for (let i = 0; i < mediaElements.length; i++) {
          if (mediaElements[i].dataset.mediaId === targetMediaId) {
            targetIndex = parseInt(mediaElements[i].dataset.index, 10);
            break;
          }
        }
        if (targetIndex === -1) return;

        const galleryInstance = gallery._revGalleryInstance;
        if (galleryInstance && typeof galleryInstance.scrollToIndex === 'function') {
          galleryInstance.scrollToIndex(targetIndex, 'auto');
        }
      }, 150);
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // product card: gallery selected variant autoscroll
  const cards = document.querySelectorAll('.rev-product-card');
  cards.forEach(card => {
    const selectorEl = card.querySelector('.rev-variant-selector[data-context="card"]');
    if (!selectorEl) return;
    const checkedInput = selectorEl.querySelector('input[type="radio"]:checked, select');
    if (!checkedInput) return;
    // Poll until gallery is initialized before triggering change
    const waitForGallery = (attempts = 0) => {
      if (attempts > 50) return; // Give up after ~2.5 seconds (50 * 50ms)
      const gallery = card.querySelector('.rev-product-gallery');
      if (!gallery || !gallery._revGalleryInstance) {
        setTimeout(() => waitForGallery(attempts + 1), 50);
        return;
      }
      // Gallery is ready, trigger the change event
      const changeEvent = new Event('change', { bubbles: true });
      checkedInput.dispatchEvent(changeEvent);
    };
    // Start polling after brief delay
    setTimeout(() => waitForGallery(), 50);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  // product main: gallery selected variant autoscroll (for non-product pages)
  const mains = document.querySelectorAll('.rev-product-main');
  mains.forEach(main => {
    const form = main.querySelector('form.rev-product-form');
    const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
    const variantId = idInput?.value;
    if (!variantId) return;
    const selectorEl = main.querySelector('.rev-variant-selector[data-context="main"]');
    const cfgScript = selectorEl?.querySelector('.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent.trim());
    } catch (e) {
      return;
    }
    const variant = cfg.variants.find(v => v.id === parseInt(variantId, 10));
    if (!variant?.feat_media) return;
    const waitForGallery = (attempts = 0) => {
      if (attempts > 50) return; // Give up after ~2.5 seconds
      const gallery = main.querySelector('.rev-product-gallery');
      if (!gallery || !gallery._revGalleryInstance) {
        setTimeout(() => waitForGallery(attempts + 1), 50);
        return;
      }
      // Gallery is ready, do the autoscroll
      const targetMediaId = variant.feat_media.toString();
      const mediaElements = gallery.querySelectorAll('[data-media-id]');
      let targetIndex = -1;
      for (let i = 0; i < mediaElements.length; i++) {
        if (mediaElements[i].dataset.mediaId === targetMediaId) {
          targetIndex = parseInt(mediaElements[i].dataset.index, 10);
          break;
        }
      }
      if (targetIndex === -1) return;
      const galleryInstance = gallery._revGalleryInstance;
      if (galleryInstance && typeof galleryInstance.scrollToIndex === 'function') {
        galleryInstance.scrollToIndex(targetIndex, 'auto');
      }
    };
    // Start polling after brief delay
    setTimeout(() => waitForGallery(), 50);
  });
});

// Variant Combination Helpers
function variantMatches(v, selected) {
  return selected.every((val, idx) => {
    if (!val) return true;
    return v[`option${idx + 1}`] === val;
  });
}

function getValidValuesByOption(variants, selected) {
  const valid = [new Set(), new Set(), new Set()];

  for (let optIdx = 0; optIdx < 3; optIdx++) {
    const partial = selected.slice();
    partial[optIdx] = null;

    variants.forEach(v => {
      if (!variantMatches(v, partial)) return;
      const val = v[`option${optIdx + 1}`];
      if (val != null) valid[optIdx].add(val);
    });
  }

  return valid;
}

function updateOptionDisables(selectorEl, validSets) {
  // Radios / swatches
  selectorEl.querySelectorAll('input[data-option-position]').forEach(input => {
    const idx = parseInt(input.dataset.optionPosition, 10) - 1;
    const isValid = validSets[idx]?.has(input.value);

    input.dataset.revInvalid = (!isValid).toString();

    const wrap = input.closest('.rev-swatch-option');
    if (wrap) {
      wrap.classList.toggle('rev-swatch-disabled', !isValid);
      wrap.setAttribute('aria-disabled', (!isValid).toString());
    }
  });

  // Select dropdowns: never disable option1 (position 1 / idx 0)
  selectorEl.querySelectorAll('select[data-option-position]').forEach(select => {
    const idx = parseInt(select.dataset.optionPosition, 10) - 1;
    const isPrimary = idx === 0;

    Array.from(select.options).forEach(opt => {
      if (!opt.value) return;
      const isValid = validSets[idx]?.has(opt.value);

      // Primary dropdown stays selectable; others get disabled normally
      opt.disabled = !isPrimary && !isValid;
    });
  });
}

function findBestVariant(variants, selected, changedIdx) {
  const wantedValue = selected[changedIdx];
  if (!wantedValue) return null;

  // Only consider variants that match what the user just changed
  const candidates = variants.filter(v => v[`option${changedIdx + 1}`] === wantedValue);
  if (!candidates.length) return null;

  // Hierarchy: preserve earlier option positions first (excluding changedIdx)
  // Example:
  // changedIdx = 0 => prefer option2, then option3
  // changedIdx = 1 => prefer option1, then option3
  // changedIdx = 2 => prefer option1, then option2
  const priority = [0, 1, 2].filter(i => i !== changedIdx);

  const matchesAt = (v, idx) => {
    const want = selected[idx];
    if (!want) return false; // if nothing selected there, don't use it to rank
    return v[`option${idx + 1}`] === want;
  };

  const compare = (a, b) => {
    // 1) Lexicographic hierarchy on options
    for (const idx of priority) {
      const aMatch = matchesAt(a, idx);
      const bMatch = matchesAt(b, idx);
      if (aMatch !== bMatch) return aMatch ? -1 : 1; // match wins
    }

    // 2) Optional: prefer available
    if (Boolean(a.available) !== Boolean(b.available)) return a.available ? -1 : 1;

    // 3) Deterministic tie-breaker: lowest id wins
    return (a.id || 0) - (b.id || 0);
  };

  return candidates.slice().sort(compare)[0];
}

function applyVariantToUI(selectorEl, variant) {
  const vals = [variant.option1, variant.option2, variant.option3];

  selectorEl.querySelectorAll('input[type="radio"][data-option-position]').forEach(inp => {
    const idx = parseInt(inp.dataset.optionPosition, 10) - 1;
    inp.checked = inp.value === vals[idx];
  });

  selectorEl.querySelectorAll('select[data-option-position]').forEach(sel => {
    const idx = parseInt(sel.dataset.optionPosition, 10) - 1;
    if (vals[idx] != null) sel.value = vals[idx];
  });

  selectorEl.querySelectorAll('.rev-swatch-option')
    .forEach(el => el.classList.remove('rev-option-active'));

  selectorEl.querySelectorAll('input[type="radio"]:checked')
    .forEach(inp => inp.closest('.rev-swatch-option')?.classList.add('rev-option-active'));
}

function readSelectedFromUI(selectorEl) {
  const selected = [];
  selectorEl.querySelectorAll('[data-option-position]').forEach(el => {
    const idx = parseInt(el.dataset.optionPosition, 10) - 1;
    if (el.type === 'radio' && el.checked) selected[idx] = el.value;
    if (el.tagName === 'SELECT') selected[idx] = el.value;
  });
  return selected;
}

function recomputeAndApplyDisables(selectorEl, variants) {
  const selected = readSelectedFromUI(selectorEl);
  const validSets = getValidValuesByOption(variants, selected);
  updateOptionDisables(selectorEl, validSets);
}

function initVariantSelectorState(root = document) {
  root.querySelectorAll('.rev-variant-selector').forEach(selectorEl => {
    const cfgScript = selectorEl.querySelector('.rev-cfg');
    if (!cfgScript) return;
    let cfg;
    try {
      cfg = JSON.parse(cfgScript.textContent.trim());
    } catch {
      return;
    }
    recomputeAndApplyDisables(selectorEl, cfg.variants);
  });
}

// Active Class Change
document.addEventListener('change', function (e) {
  if (e.target.type === 'radio' && e.target.closest('.rev-variant-selector')) {
    const radioInput = e.target;
    const variantSelector = radioInput.closest('.rev-variant-selector');
    const radioName = radioInput.name;

    const relatedSwatches = variantSelector.querySelectorAll(
      `input[type="radio"][name="${radioName}"]`
    );

    relatedSwatches.forEach(function (radio) {
      const swatchOption = radio.closest('.rev-swatch-option');
      if (swatchOption) {
        swatchOption.classList.remove('rev-option-active');
      }
    });

    const selectedSwatchOption = radioInput.closest('.rev-swatch-option');
    if (selectedSwatchOption) {
      selectedSwatchOption.classList.add('rev-option-active');
    }
  }
});

// Change ATC Variant ID
document.addEventListener('change', function (e) {
  const selector = e.target.closest('.rev-variant-selector');
  if (!selector) return;

  // Detect context: product card or product main section
  const context = selector.dataset.context;
  if (!context) return;

  const isMainContext = context === 'main';
  const contextEl = isMainContext
    ? selector.closest('.rev-product-main')
    : selector.closest('.rev-product-card')

  if (!contextEl) return;

  const cfgScript = selector.querySelector('.rev-cfg');
  if (!cfgScript) return;
  let cfg;
  try {
    cfg = JSON.parse(cfgScript.textContent.trim());
  } catch {
    return;
  }
  const variants = cfg.variants;

  const selected = [];

  selector.querySelectorAll('[data-option-position]').forEach(el => {
    const pos = parseInt(el.dataset.optionPosition, 10) - 1;
    if (el.type === 'radio' && el.checked) selected[pos] = el.value;
    if (el.tagName === 'SELECT') selected[pos] = el.value;
  });

  if (!selected[0]) return; // option1 is required

  const changedEl = e.target.closest('[data-option-position]');
  const changedIdx = changedEl
    ? parseInt(changedEl.dataset.optionPosition, 10) - 1
    : 0;

  // 1) Disable impossible option values
  const validSets = getValidValuesByOption(variants, selected);
  updateOptionDisables(selector, validSets);

  // 2) Resolve variant
  let variant = variants.find(v =>
    v.option1 === selected[0] &&
    (selected[1] == null || v.option2 === selected[1]) &&
    (selected[2] == null || v.option3 === selected[2])
  );

  // 3) Snap if invalid
  if (!variant) {
    variant = findBestVariant(variants, selected, changedIdx);
    if (!variant) return;

    applyVariantToUI(selector, variant);

    selected[0] = variant.option1;
    selected[1] = variant.option2;
    selected[2] = variant.option3;

    // Recalculate disables after snapping
    const validSetsAfter = getValidValuesByOption(variants, selected);
    updateOptionDisables(selector, validSetsAfter);
  }

  const form = contextEl.querySelector('form.rev-product-form');
  const idInput = form?.querySelector('input[name="id"], [data-rev-variant-id]');
  if (idInput) idInput.value = variant.id;

  // Context: Main | URL update
  if (isMainContext && window.location.pathname.includes('/products/')) {
    // update PDP url variant param
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  // Context: Applies to Main and Card
  selector.querySelectorAll('.rev-legend span').forEach((span, idx) => {
    if (selected[idx]) {
      span.textContent = selected[idx];
    }
  });

  if (isMainContext) {
    // Context: Main | Block updates
    RevClientUpdate.price(contextEl, variant, '.rev-block-price');
    RevClientUpdate.buyButtons(contextEl, variant, '.rev-block-buy-buttons');
    RevClientUpdate.inventory(contextEl, variant, '.rev-block-inventory');
    RevClientUpdate.klaviyoBis(contextEl, variant);
  } else {
    // Context: Card | updates
    RevClientUpdate.price(contextEl, variant);
    RevClientUpdate.buyButtons(contextEl, variant);
  }

  const gallery = contextEl.querySelector('.rev-product-gallery');
  const variantMetadata = gallery?.dataset.variantMetadata === 'true';

  let shouldAutoscrollGallery = false;
  if (variantMetadata) {
    RevClientUpdate.gallery(contextEl, variant);
  } else {
    if (variant.feat_media) {
      shouldAutoscrollGallery = true;
    }
  }

  if (shouldAutoscrollGallery) {
    setTimeout(() => {
      const gallery = contextEl.querySelector('.rev-product-gallery');
      if (gallery && variant.feat_media) {
        const isSlider = gallery.classList.contains('rev-product-gallery-slider');
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const targetMediaId = variant.feat_media.toString();
        const mediaElements = gallery.querySelectorAll('[data-media-id]');
        let targetIndex = -1;
        let targetElement = null;
        for (let i = 0; i < mediaElements.length; i++) {
          if (mediaElements[i].dataset.mediaId === targetMediaId) {
            targetIndex = parseInt(mediaElements[i].dataset.index, 10);
            targetElement = mediaElements[i];
            break;
          }
        }
        if (targetIndex === -1) return;
        if (isMobile || isSlider) {
          const galleryInstance = gallery._revGalleryInstance;
          if (galleryInstance && typeof galleryInstance.scrollToIndex === 'function') {
            galleryInstance.scrollToIndex(targetIndex, 'smooth');
          }
        } else {
          if (targetElement) {
            const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;
            const scrollTarget = elementTop - 250;
            window.scrollTo({ top: Math.max(0, scrollTarget), behavior: 'smooth' });
          }
        }
      }
    }, 150);
  }
});

// ================================
// PDP Checkbox Upsell
// Prevent default theme JS interactions
// ================================
document.addEventListener('click', function (e) {
  const upsell = e.target.closest('.rev-checkbox');
  if (!upsell) return;
  e.preventDefault();
  e.stopPropagation();
  const input = upsell.querySelector('.rev-checkbox__toggle');
  if (!input) return;
  input.checked = !input.checked;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// ================================
// Subscription Helper
// ================================
function getSubscriptionSelection(contextEl) {
  const fieldset = contextEl.querySelector('[data-subscription-plan]');
  if (!fieldset) {
    return { hasSubscriptionUI: false, purchaseOption: 'onetime', sellingPlanId: null };
  }

  const checked = fieldset.querySelector('input[name="purchase_option"]:checked');
  const purchaseOption = (checked?.value || 'onetime').toLowerCase();

  // Only needed if subscription is selected
  let sellingPlanId = null;
  if (purchaseOption === 'subscription') {
    const select = fieldset.querySelector('select[name="selling_plan"]');
    sellingPlanId = select?.value ? String(select.value) : null;
  }

  return { hasSubscriptionUI: true, purchaseOption, sellingPlanId };
}

// ================================
// Universal Add To Cart Handler
// ================================
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.rev-atc-button');
  if (!btn) return;

  // Ignore if inside a popup (has its own specific handler)
  if (btn.closest('.rev-popup-overlay')) return;

  const card = btn.closest('.rev-product-card');
  const main = btn.closest('.rev-product-main');
  const contextEl = card || main;
  const isMainContext = !!main;

  if (!contextEl) return;

  // prevent double-click/double-fire from native theme listeners
  if (btn.dataset.revBusy === '1') return;
  btn.dataset.revBusy = '1';

  const form = contextEl.querySelector('form.rev-product-form');
  const idInput = form?.querySelector('input[name="id"]');
  const variantId = idInput?.value || btn.dataset.variantId;
  if (!variantId) {
    delete btn.dataset.revBusy;
    return;
  }

  const action = (btn.dataset.action || 'add_to_cart').toLowerCase();

  // Validate required custom inputs (main context only)
  if (isMainContext) {
    const requiredInputs = main.querySelectorAll('.rev-custom-input__field[data-rev-required="true"]');
    let hasValidationError = false;

    requiredInputs.forEach(input => {
      const wrapper = input.closest('.rev-custom-input');
      const isEmpty = !input.value || input.value.trim() === '';

      if (isEmpty) {
        hasValidationError = true;
        wrapper.classList.add('rev-validation-error');

        // Remove error state when user starts typing
        input.addEventListener('input', function clearError() {
          wrapper.classList.remove('rev-validation-error');
          input.removeEventListener('input', clearError);
        }, { once: true });
      }
    });

    if (hasValidationError) {
      console.warn('Please fill in all required fields');
      delete btn.dataset.revBusy;
      return;
    }
  }

  let quantity = 1;
  if (isMainContext) {
    const qtySelector = main.querySelector('.rev-qty-selector');
    if (qtySelector) {
      const qtyInput = qtySelector.querySelector('input[type="number"]');
      if (qtyInput) {
        quantity = parseInt(qtyInput.value, 10) || 1;
      }
    }
  }

  addToCart({
    variantId,
    quantity,
    btn,
    contextEl,
    isMainContext,
    action,
  });
}, { passive: false });

async function addToCart({ variantId, quantity, btn, contextEl, isMainContext, action }) {
  try {
    btn.disabled = true;
    btn.classList.add('loading');

    const items = [{ id: variantId, quantity }];

    const { hasSubscriptionUI, purchaseOption, sellingPlanId } = getSubscriptionSelection(contextEl);
    if (hasSubscriptionUI && purchaseOption === 'subscription') {
      if (!sellingPlanId) {
        console.warn('Subscription selected but no selling plan found.');
      } else {
        items[0].selling_plan = sellingPlanId;
      }
    }

    // Add custom input properties (main context only)
    if (isMainContext) {
      const mainProductProperties = {};
      const customInputs = contextEl.querySelectorAll('.rev-custom-input__field');

      customInputs.forEach(input => {
        if (input.value && input.value.trim() !== '') {
          // Extract property name from name="properties[PropertyName]"
          const nameAttr = input.getAttribute('name') || '';
          const match = nameAttr.match(/properties\[([^\]]+)\]/);
          if (match && match[1]) {
            const propertyName = match[1];
            mainProductProperties[propertyName] = input.value.trim();
          }
        }
      });

      // Add properties to main product item if any exist
      if (Object.keys(mainProductProperties).length > 0) {
        items[0].properties = mainProductProperties;
      }

      // Add upsell products with their line item properties
      const mainProductTitle = contextEl.querySelector('.rev-block-title, h1[class*="heading"]');
      const mainProductTitleText = mainProductTitle ? mainProductTitle.textContent.trim() : 'Product';

      const checkedUpsells = contextEl.querySelectorAll('.rev-checkbox-upsell input[type="checkbox"]:checked');
      checkedUpsells.forEach(checkbox => {
        const upsellVariantId = checkbox.dataset.variantId;
        if (upsellVariantId) {
          items.push({
            id: upsellVariantId,
            quantity: 1,
            properties: {
              'Added with': mainProductTitleText
            }
          });
        }
      });
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!res.ok) throw new Error('Failed to add');

    // Check for amazon coupon checkbox and apply discount after adding to cart
    const couponCheckbox = contextEl.querySelector('.amazon-coupon-checkbox:checked[data-discount-code]');
    if (couponCheckbox) {
      const discountCode = couponCheckbox.dataset.discountCode;
      if (discountCode && discountCode.trim() !== '') {
        try {
          // Apply discount via Shopify's discount URL
          const discountUrl = `/discount/${encodeURIComponent(discountCode.trim())}?redirect=${encodeURIComponent(window.location.pathname)}`;
          await fetch(discountUrl, {
            method: 'GET',
            credentials: 'include',
            redirect: 'follow'
          });
          // Small delay to ensure discount is applied to cart
          await new Promise(resolve => setTimeout(resolve, 150));
        } catch (err) {
          console.warn('Failed to apply discount code:', err);
        }
      }
    }

    // Check for buy button auto-discount and apply after coupon (if any)
    const btnDiscountCode = btn.dataset.discountCode;
    if (btnDiscountCode && btnDiscountCode.trim() !== '') {
      try {
        // Apply discount via Shopify's discount URL
        const discountUrl = `/discount/${encodeURIComponent(btnDiscountCode.trim())}?redirect=${encodeURIComponent(window.location.pathname)}`;
        await fetch(discountUrl, {
          method: 'GET',
          credentials: 'include',
          redirect: 'follow'
        });
        // Small delay to ensure discount is applied to cart
        await new Promise(resolve => setTimeout(resolve, 150));
      } catch (err) {
        // Silent failure - likely means coupon already applied and can't stack
      }
    }

    document.body.classList.add('rev-item-added');
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true })
    );

    setTimeout(() => {
      if (action === 'buy_now') {
        window.location.assign('/checkout');
      } else {
        revOpenCartDrawer({ fallbackToCartPage: false });
      }
    }, 50);

  } catch (err) {
    console.error('Error adding to cart:', err);
  } finally {
    delete btn.dataset.revBusy;
    btn.disabled = false;
    btn.classList.remove('loading');
  }
}

// ================================
// Open Cart Drawer - Theme Agnostic
// ================================
function revOpenCartDrawer({ fallbackToCartPage = false } = {}) {
  // 1) Dawn/OS2 cart drawer custom element (common)
  const drawerEl =
    document.querySelector('cart-drawer') ||
    document.querySelector('cart-drawer-drawer') ||
    document.querySelector('#CartDrawer') ||
    document.querySelector('[id*="CartDrawer"]');

  // If the element has an open/show method, try it.
  try {
    if (drawerEl?.open) { drawerEl.open(); return true; }
    if (drawerEl?.show) { drawerEl.show(); return true; }
  } catch (_) { }

  // 2) Click common cart-toggle triggers (most themes wire these)
  const triggers = [
    '[aria-controls="CartDrawer"]',
    '[aria-controls="cart-drawer"]',
    '[data-cart-toggle]',
    '[data-drawer-trigger="cart"]',
    'a[href="/cart"][role="button"]',
    'button[name="cart"]',
    '.header__icon--cart',
    '.site-header__cart',
    '.cart-link',
  ];

  for (const sel of triggers) {
    const el = document.querySelector(sel);
    if (!el) continue;
    // Dispatch a real click sequence
    el.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true, cancelable: true }));
    el.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
    el.click();
    return true;
  }

  // 3) Last resort: go to cart page (optional)
  if (fallbackToCartPage) window.location.href = '/cart';
  return false;
}

// ================================
// Currency Conversion Helper
// ================================
let __revCurrencyLibPromise = null;

function ensureCurrencyLib() {
  if (window.Currency?.convert) return Promise.resolve();

  if (__revCurrencyLibPromise) return __revCurrencyLibPromise;

  __revCurrencyLibPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load currencies.js'));
    document.head.appendChild(script);
  });

  return __revCurrencyLibPromise;
}

async function convertCents(cents, from, to) {
  // no-op cases
  const amount = Number(cents || 0);
  if (!from || !to || from === to) return amount;

  // ensure lib
  await ensureCurrencyLib();

  // guard if rates missing
  if (!window.Currency?.rates?.[from] || !window.Currency?.rates?.[to]) return amount;

  // currencies.js works in "major" units
  const major = amount / 100;
  const convertedMajor = Currency.convert(major, from, to);
  return Math.round(convertedMajor * 100);
}

// Micro-cache for shop->cart conversions (per currency pair)
const __revFxCache = new Map(); // key: "USD->GBP:5000" or for more general: "USD->GBP:rate"
async function convertCentsCached(cents, from, to) {
  const key = `${from}->${to}:${cents}`;
  if (__revFxCache.has(key)) return __revFxCache.get(key);
  const v = await convertCents(cents, from, to);
  __revFxCache.set(key, v);
  return v;
}

// ================================
// Triggered Popups Engine
// ================================
(function () {
  if (window.__REV_POPUP_ENGINE__) return; // prevent double-init
  window.__REV_POPUP_ENGINE__ = true;

  const instances = new Map();
  const triggers = new Map();
  let globalListenersBound = false;

  function parseConfig(overlay) {
    const cfgEl = overlay.querySelector('.rev-popup-config');
    if (!cfgEl) return null;
    try {
      const cfg = JSON.parse(cfgEl.textContent.trim());
      if (!cfg.sectionId) return null;
      return cfg;
    } catch {
      return null;
    }
  }

  function makeStorageKeys(sectionId) {
    return {
      popupShown: `revPopupShown_${sectionId}`,
      pageviews: `revPopupPageviews_${sectionId}`,
      visitorFirstSeen: 'revPopupFirstVisit',
      trafficSource: 'revPopupTrafficSource'
    };
  }

  function getTrafficSource(cfg) {
    const keys = makeStorageKeys(cfg.sectionId);
    const stored = localStorage.getItem(keys.trafficSource);
    if (stored) return stored;

    const params = new URLSearchParams(window.location.search);
    const utm_source = (params.get('utm_source') || '').toLowerCase();
    const utm_medium = (params.get('utm_medium') || '').toLowerCase();
    const referrer = (document.referrer || '').toLowerCase();

    let source = 'unknown';

    if (utm_source || utm_medium) {
      if (utm_source.includes('facebook') || utm_source.includes('instagram') || utm_source.includes('fb') || utm_source.includes('ig')) source = 'meta';
      else if (utm_source.includes('google') || utm_medium.includes('cpc') || utm_medium.includes('ppc')) source = 'google';
      else if (utm_source.includes('klaviyo') || utm_source.includes('email')) source = 'klaviyo';
      else if (utm_source.includes('tiktok')) source = 'tiktok';
      else if (utm_source.includes('snapchat') || utm_source.includes('snap')) source = 'snapchat';
    }

    if (source === 'unknown') {
      if (!referrer) source = 'direct';
      else if (referrer.includes('facebook.com') || referrer.includes('instagram.com')) source = 'meta';
      else if (referrer.includes('google.com') || referrer.includes('google.')) source = 'google';
      else if (referrer.includes('tiktok.com')) source = 'tiktok';
      else if (referrer.includes('snapchat.com')) source = 'snapchat';
    }

    localStorage.setItem(keys.trafficSource, source);
    return source;
  }

  function passesFilters(inst) {
    const cfg = inst.config;
    if (!cfg.filteringEnabled) return true;

    if (cfg.filterDevice && cfg.filterDevice !== 'all') {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (cfg.filterDevice === 'mobile' && !isMobile) return false;
      if (cfg.filterDevice === 'desktop' && isMobile) return false;
    }

    if (cfg.filterVisitorStatus && cfg.filterVisitorStatus !== 'all') {
      const keys = inst.storageKeys;
      const firstVisit = localStorage.getItem(keys.visitorFirstSeen);
      const isNew = !firstVisit;
      if (!firstVisit) localStorage.setItem(keys.visitorFirstSeen, Date.now().toString());

      if (cfg.filterVisitorStatus === 'new' && !isNew) return false;
      if (cfg.filterVisitorStatus === 'returning' && isNew) return false;
    }

    if (cfg.filterTrafficSource) {
      const source = getTrafficSource(cfg);
      const allowed = [];
      if (cfg.filterTrafficUnknown) allowed.push('unknown');
      if (cfg.filterTrafficDirect) allowed.push('direct');
      if (cfg.filterTrafficMeta) allowed.push('meta');
      if (cfg.filterTrafficGoogle) allowed.push('google');
      if (cfg.filterTrafficKlaviyo) allowed.push('klaviyo');
      if (cfg.filterTrafficTikTok) allowed.push('tiktok');
      if (cfg.filterTrafficSnapchat) allowed.push('snapchat');
      if (allowed.length && !allowed.includes(source)) return false;
    }

    return true;
  }

  async function getCartInfo() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return {
        total: Number(cart.total_price || 0),
        currency: cart.currency || null
      };
    } catch {
      return { total: 0, currency: null };
    }
  }

  async function getPopupThresholdInCartCurrency(inst, cartCurrency) {
    // Only apply to ATC-triggered popups with a non-zero threshold
    if (!inst?.config?.triggerATC) return null;

    const raw = Number(inst.config.cartThreshold || 0);
    if (!raw || raw <= 0) return null;

    const from = inst.config.shopCurrency;
    const to = cartCurrency;

    if (from && to && from !== to) {
      return await convertCentsCached(raw, from, to);
    }
    return raw;
  }

  async function refreshThresholdTriggerButtons() {
    const els = document.querySelectorAll('[data-rev-popup-open][data-rev-popup-requires-threshold]');
    if (!els.length) return;
    const { total, currency: cartCurrency } = await getCartInfo();

    // cache threshold calc per trigger key per refresh run
    const thresholdCache = new Map();

    for (const el of els) {
      const key = (el.getAttribute('data-rev-popup-open') || '').trim();
      if (!key) continue;

      const sectionId = triggers.get(key);
      const inst = instances.get(sectionId);

      if (!inst) {
        el.style.display = 'none';
        continue;
      }

      // Get threshold for this popup in cart currency
      let threshold = thresholdCache.get(key);
      if (threshold === undefined) {
        threshold = await getPopupThresholdInCartCurrency(inst, cartCurrency);
        thresholdCache.set(key, threshold);
      }

      // If popup has no threshold requirement, show button
      if (threshold === null) {
        el.style.display = 'block';
        continue;
      }

      // Show only if cart meets threshold
      el.style.display = total >= threshold ? 'block' : 'none';
    }
  }

  function debounce(fn, wait = 150) {
    let t = null;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  function observeTriggerRerenders() {
    // Debounced so a big cart re-render doesn’t spam /cart.js
    const refreshDebounced = debounce(() => {
      refreshThresholdTriggerButtons();
    }, 200);

    // Run once immediately in case cart re-render happened before observer
    refreshDebounced();

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        // New nodes inserted (cart re-render commonly does this)
        if (m.type === 'childList' && (m.addedNodes?.length || m.removedNodes?.length)) {
          for (const node of m.addedNodes) {
            if (node.nodeType !== 1) continue;

            // Node itself is a trigger
            if (node.matches?.('[data-rev-popup-open][data-rev-popup-requires-threshold]')) {
              refreshDebounced();
              return;
            }

            // Or contains triggers
            if (node.querySelector?.('[data-rev-popup-open][data-rev-popup-requires-threshold]')) {
              refreshDebounced();
              return;
            }
          }
        }

        // Some themes toggle attributes/styles instead of replacing nodes
        if (m.type === 'attributes') {
          const el = m.target;
          if (
            el?.matches?.('[data-rev-popup-open][data-rev-popup-requires-threshold]') &&
            (m.attributeName === 'style' ||
              m.attributeName === 'class' ||
              m.attributeName === 'data-rev-popup-open' ||
              m.attributeName === 'data-rev-popup-requires-threshold')
          ) {
            refreshDebounced();
            return;
          }
        }
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'style',
        'class',
        'data-rev-popup-open',
        'data-rev-popup-requires-threshold'
      ]
    });

    // Optional: expose for debugging / teardown
    window.__REV_POPUP_TRIGGER_OBSERVER__ = observer;
  }

  function hasBeenShown(inst) {
    if (!inst.config.showOnce) return false;
    return localStorage.getItem(inst.storageKeys.popupShown) === 'true';
  }

  function markShown(inst) {
    if (!inst.config.showOnce) return;
    localStorage.setItem(inst.storageKeys.popupShown, 'true');
  }

  function log(inst, msg, data) {
    if (inst.config.enableConsoleLog) {
      console.log(`[RevFlare Popup ${inst.config.sectionId}] ${msg}`, data || '');
    }
  }

  function show(inst, force = false) {
    if (!force && hasBeenShown(inst)) return;
    const overlay = inst.overlay;
    if (!overlay) return;

    overlay.style.display = 'flex';
    void overlay.offsetWidth;

    // If AB test css hide the popup (e.g. display:none !important) it remains hidden
    const cs = window.getComputedStyle(overlay);
    if (cs.display === 'none' || cs.visibility === 'hidden') {
      log(inst, 'Popup suppressed by CSS (A/B test). Skipping show.');
      overlay.style.display = 'none';
      return;
    }

    const delay = force ? 0 : (inst.config.displayDelay || 0);

    window.setTimeout(() => {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Re-check after activation in case CSS hides it when .active is applied
      const cs2 = window.getComputedStyle(overlay);
      if (cs2.display === 'none' || cs2.visibility === 'hidden') {
        log(inst, 'Popup suppressed after activation. Reverting.');
        overlay.classList.remove('active');
        overlay.style.display = 'none';

        const anyOpen = document.querySelectorAll('.rev-popup-overlay.active').length > 0;
        if (!anyOpen) document.body.style.overflow = '';
        return;
      }

      if (!force) markShown(inst);
      log(inst, 'Popup displayed', force ? '(forced)' : '');
    }, delay);
  }


  function hide(inst) {
    const overlay = inst.overlay;
    if (!overlay) return;

    overlay.classList.add('closing');
    overlay.classList.remove('active');

    window.setTimeout(() => {
      overlay.classList.remove('closing');
      overlay.style.display = 'none';

      const anyOpen = document.querySelectorAll('.rev-popup-overlay.active').length > 0;
      if (!anyOpen) document.body.style.overflow = '';
    }, 600);
  }

  function revealThresholdButtonsForKey(triggerKey) {
    const key = (triggerKey || '').trim();
    if (!key) return;

    document
      .querySelectorAll(`[data-rev-popup-open="${CSS.escape(key)}"][data-rev-popup-requires-threshold]`)
      .forEach((el) => {
        el.style.display = 'block';
      });
  }

  async function checkAndShow(inst, triggerSource) {
    log(inst, 'Checking popup conditions', { triggerSource });

    if (hasBeenShown(inst)) return;
    if (!passesFilters(inst)) return;

    if ((triggerSource === 'atc' || triggerSource === 'cart_change') && inst.config.triggerATC) {
      const { total, currency: cartCurrency } = await getCartInfo();

      let threshold = Number(inst.config.cartThreshold || 0);
      const from = inst.config.shopCurrency;
      const to = cartCurrency;

      if (from && to && from !== to) {
        threshold = await convertCentsCached(threshold, from, to);
      }

      if (total < threshold) return;
      revealThresholdButtonsForKey(inst.config.triggerKey);
    }

    show(inst, false);
  }

  function bindPerInstanceUI(inst) {
    const sectionId = inst.config.sectionId;

    const closeBtn = inst.overlay.querySelector(`#revPopupClose-${CSS.escape(sectionId)}`);
    if (closeBtn) closeBtn.addEventListener('click', () => hide(inst));

    inst.overlay.addEventListener('click', (e) => {
      if (e.target === inst.overlay) hide(inst);
    });

    // POPUP-SPECIFIC ADD TO CART HANDLER
    inst.overlay.querySelectorAll('.rev-atc-button').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        const originalAria = btn.getAttribute('aria-label') || '';
        try {
          btn.disabled = true;
          btn.classList.add('loading');
          btn.setAttribute('aria-busy', 'true');
          btn.setAttribute('aria-label', 'Adding to cart');

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-REV-POPUP-ATC': '1'
            },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });

          if (!res.ok) throw new Error('Failed to add');

          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

          // open cart + close popup (your existing UX)
          setTimeout(() => revOpenCartDrawer({ fallbackToCartPage: false }), 50);
          setTimeout(() => hide(inst), 150);

        } catch (err) {
          log(inst, 'Error adding to cart', err);
        } finally {
          btn.classList.remove('loading');
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.setAttribute('aria-label', originalAria);
        }
      });
    });
  }

  function registerAll() {
    document.querySelectorAll('.rev-popup-overlay[data-section-id]').forEach((overlay) => {
      const cfg = parseConfig(overlay);
      if (!cfg) return;

      const sectionId = cfg.sectionId;
      if (instances.has(sectionId)) return;

      const inst = {
        overlay,
        config: cfg,
        storageKeys: makeStorageKeys(sectionId),
        state: {
          scrollTriggered: false,
          exitIntentTriggered: false,
          timeTriggered: false
        }
      };

      instances.set(sectionId, inst);
      const key = (cfg.triggerKey || '').trim();
      if (key) {
        triggers.set(key, sectionId);
      }
      bindPerInstanceUI(inst);

      // per-instance triggers (not gloabl)
      if (cfg.triggerPageview) {
        const key = inst.storageKeys.pageviews;
        const count = (parseInt(localStorage.getItem(key) || '0', 10) || 0) + 1;
        localStorage.setItem(key, String(count));
        if (count >= (cfg.pageviewThreshold || 0)) checkAndShow(inst, 'pageview');
      }

      if (cfg.triggerTime && (cfg.timeThreshold || 0) > 0) {
        window.setTimeout(() => {
          if (inst.state.timeTriggered) return;
          inst.state.timeTriggered = true;
          checkAndShow(inst, 'time_delay');
        }, cfg.timeThreshold);
      }
    });

    // global API
    if (!window.RevFlarePopups) window.RevFlarePopups = {};
    instances.forEach((inst, sectionId) => {
      window.RevFlarePopups[sectionId] = {
        open: () => show(inst, true),
        close: () => hide(inst),
        reset: () => {
          localStorage.removeItem(inst.storageKeys.popupShown);
          inst.state.scrollTriggered = false;
          inst.state.exitIntentTriggered = false;
          inst.state.timeTriggered = false;
        },
        resetPageviews: () => localStorage.removeItem(inst.storageKeys.pageviews),
        getSectionId: () => sectionId
      };
    });

    if (!window.RevFlarePopup) {
      window.RevFlarePopup = {
        get: (sectionId) => window.RevFlarePopups?.[sectionId],
        getAll: () => window.RevFlarePopups,
        openById: (sectionId) => window.RevFlarePopups?.[sectionId]?.open?.(),
        closeAll: () => Object.values(window.RevFlarePopups || {}).forEach(p => p.close?.()),
        resetAll: () => Object.values(window.RevFlarePopups || {}).forEach(p => p.reset?.())
      };
    }
  }

  function bindGlobalListenersOnce() {
    if (globalListenersBound) return;
    globalListenersBound = true;

    document.addEventListener('click', (e) => {
      const el = e.target.closest('[data-rev-popup-open]');
      if (!el) return;
      const key = (el.getAttribute('data-rev-popup-open') || '').trim();
      if (!key) return;
      const sectionId = triggers.get(key);
      // Allow fallback to direct sectionId passed intentionally
      const popup = window.RevFlarePopups?.[sectionId] || window.RevFlarePopups?.[key];
      popup?.open?.();
    });

    let scrollTimeout;
    window.addEventListener('scroll', () => {
      if (scrollTimeout) return;
      scrollTimeout = window.setTimeout(() => {
        const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;

        instances.forEach((inst) => {
          const cfg = inst.config;

          if (cfg.triggerScrollDepth && !inst.state.scrollTriggered) {
            if (scrollPercent >= (cfg.scrollDepthThreshold || 0)) {
              inst.state.scrollTriggered = true;
              checkAndShow(inst, 'scroll_depth');
            }
          }

          if (cfg.triggerExitIntent && !inst.state.exitIntentTriggered) {
            const isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (isMobile) {
              inst._lastScrollY = inst._lastScrollY ?? window.scrollY;
              const last = inst._lastScrollY;
              const current = window.scrollY;
              if (last - current > 60 && current < 150) {
                inst.state.exitIntentTriggered = true;
                checkAndShow(inst, 'exit_intent');
              }
              inst._lastScrollY = current;
            }
          }
        });

        scrollTimeout = null;
      }, 200);
    });

    document.addEventListener('mouseout', (e) => {
      if (!(e.clientY <= 0 && e.relatedTarget === null)) return;
      instances.forEach((inst) => {
        if (inst.config.triggerExitIntent && !inst.state.exitIntentTriggered) {
          inst.state.exitIntentTriggered = true;
          checkAndShow(inst, 'exit_intent');
        }
      });
    });

    document.addEventListener('cart:updated', () => {
      instances.forEach(inst => inst.config.triggerATC && checkAndShow(inst, 'atc'));
      refreshThresholdTriggerButtons();
    });
    document.addEventListener('product:added', () => {
      instances.forEach(inst => inst.config.triggerATC && checkAndShow(inst, 'atc'));
      refreshThresholdTriggerButtons();
    });

    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = args?.[0];
      const opts = args?.[1];

      // capture variant id if this is /cart/add
      let addedVariantId = null;
      try {
        if (typeof url === 'string' && url.includes('/cart/add') && opts?.body) {
          const body = typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
          const id = body?.items?.[0]?.id || body?.id;
          if (id) addedVariantId = String(id);
        }
      } catch (_) { }

      return originalFetch.apply(this, args).then((res) => {
        try {
          if (typeof url === 'string' && res && res.ok) {
            const cleanUrl = url.split('?')[0];
            const isCartAdd = cleanUrl.includes('/cart/add');
            const isCartChange =
              cleanUrl.includes('/cart/change') ||
              cleanUrl.includes('/cart/update') ||
              cleanUrl.includes('/cart/clear');

            if (isCartAdd || isCartChange) {
              let isPopupATC = false;

              if (isCartAdd) {
                isPopupATC = !!(opts?.headers && (
                  (opts.headers.get && opts.headers.get('X-REV-POPUP-ATC')) ||
                  opts.headers['X-REV-POPUP-ATC'] ||
                  opts.headers['x-rev-popup-atc']
                ));
              }

              window.setTimeout(() => {
                if (!isCartAdd || !isPopupATC) {
                  instances.forEach(inst =>
                    inst.config.triggerATC &&
                    checkAndShow(inst, isCartChange ? 'cart_change' : 'atc')
                  );
                }

                refreshThresholdTriggerButtons();
              }, 400);
            }
          }
        } catch (_) { }
        return res;
      });

    };

    if (window.jQuery && !window.__REV_POPUP_JQ_BOUND__) {
      window.__REV_POPUP_JQ_BOUND__ = true;
      window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
        if (settings?.url && settings.url.includes('/cart/add')) {
          window.setTimeout(() => {
            instances.forEach(inst => inst.config.triggerATC && checkAndShow(inst, 'atc'));
            refreshThresholdTriggerButtons();
          }, 500);
        }
      });
    }
  }

  function init() {
    registerAll();
    bindGlobalListenersOnce();
    refreshThresholdTriggerButtons();
    observeTriggerRerenders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ================================
// Scrolling Content
// ================================
(function () {
  function initScroller(root) {
    if (!root || root.dataset.revInit === "1") return;

    const track = root.querySelector('[data-rev-track]');
    const viewport = root.querySelector('.rev-scroll-viewport');
    const baseGroup = root.querySelector('[data-rev-group="base"]');
    const cloneGroup = root.querySelector('[data-rev-group="clone"]');
    if (!track || !viewport || !baseGroup || !cloneGroup) return;

    root.dataset.revInit = "1";

    const maxDupes = 40;

    function clearBaseDupes() {
      baseGroup.querySelectorAll('[data-rev-item-dupe="1"]').forEach(n => n.remove());
    }

    function ensureFilled() {
      clearBaseDupes();

      const baseItems = Array.from(baseGroup.querySelectorAll('[data-rev-item]'))
        .filter(el => el.getAttribute('data-rev-item-dupe') !== '1');

      if (!baseItems.length) return;
      let i = 0;
      while (baseGroup.scrollWidth < viewport.clientWidth * 1.2 && i < maxDupes) {
        baseItems.forEach(item => {
          const dupe = item.cloneNode(true);
          dupe.setAttribute('aria-hidden', 'true');
          dupe.setAttribute('data-rev-item-dupe', '1');
          baseGroup.appendChild(dupe);
        });
        i++;
      }
      cloneGroup.innerHTML = baseGroup.innerHTML;
      cloneGroup.setAttribute('aria-hidden', 'true');
    }

    ensureFilled();

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(ensureFilled);
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', ensureFilled);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rev-scroller]').forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();

// ================================
// Product Gallery
// ================================
window.RevGallery = window.RevGallery || (() => {
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

  function resetVideoInSlide(slideEl) {
    if (!slideEl) return;
    const video = slideEl.querySelector('video');
    if (!video) return;

    try { video.pause(); } catch (_) { }
    try { video.currentTime = 0; } catch (_) { }
    video.removeAttribute('controls');

    const btn = slideEl.querySelector('.rev-play');
    if (btn) {
      btn.style.display = '';
      btn.hidden = false;
    }
  }

  function setActiveUI({ thumbs, bullets, index }) {
    if (thumbs?.length) {
      thumbs.forEach(t => t.classList.toggle('is-active', Number(t.dataset.index) === index));
    }
    if (bullets?.length) {
      bullets.forEach(b => b.classList.toggle('rev-gallery-slide-bullet-active', Number(b.dataset.index) === index));
      setNextBulletUI({ bullets, index });
    }
  }

  function nearestIndexByScrollLeft(main, slides) {
    const x = main.scrollLeft;
    let best = 0;
    let bestDist = Infinity;
    for (let i = 0; i < slides.length; i++) {
      const d = Math.abs(slides[i].offsetLeft - x);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  function applyThumbsHeightAndReveal(root) {
    const thumbsWrap = root.querySelector('.rev-gallery-thumbnails');
    if (!thumbsWrap) return;
    if (!isDesktop()) {
      thumbsWrap.classList.remove('is-ready');
      thumbsWrap.style.removeProperty('--rev-thumbs-h');
      return;
    }

    const mainViewport = root.querySelector('.rev-gallery-main[data-rev-main]');
    if (!mainViewport) return;

    const h = Math.round(mainViewport.getBoundingClientRect().height);
    if (!h || h < 60) return;

    const prev = parseInt(getComputedStyle(thumbsWrap).getPropertyValue('--rev-thumbs-h')) || 0;
    if (prev && Math.abs(prev - h) < 6) {
      if (!thumbsWrap.classList.contains('is-ready')) {
        requestAnimationFrame(() => thumbsWrap.classList.add('is-ready'));
      }
      return;
    }

    thumbsWrap.style.setProperty('--rev-thumbs-h', `${h}px`);

    if (!thumbsWrap.classList.contains('is-ready')) {
      requestAnimationFrame(() => thumbsWrap.classList.add('is-ready'));
    }
  }

  function scrollThumbToIndex({ thumbsWrap, thumbByIndex, index, behavior = 'smooth' }) {
    if (!thumbsWrap) return;
    const el = thumbByIndex.get(index);
    if (!el) return;

    const wrapH = thumbsWrap.clientHeight;
    if (!wrapH) return;

    const elTop = el.offsetTop;
    const elH = el.offsetHeight || 0;

    const target = elTop - (wrapH * 0.45) + (elH / 2);
    const maxScroll = thumbsWrap.scrollHeight - wrapH;
    const nextTop = clamp(target, 0, Math.max(0, maxScroll));

    if (Math.abs(thumbsWrap.scrollTop - nextTop) < 2) return;
    thumbsWrap.scrollTo({ top: nextTop, behavior });
  }

  function setNextBulletUI({ bullets, index }) {
    if (!bullets?.length) return;
    bullets.forEach(b => b.classList.remove('rev-bullet-next'));
    const nextIndex = (index + 1) % bullets.length;
    const nextBullet = bullets.find(b => Number(b.dataset.index) === nextIndex) || bullets[0];

    if (nextBullet) nextBullet.classList.add('rev-bullet-next');
  }

  function init(root) {
    if (!root) return;
    if (root.dataset.revGalleryInit === '1') return;

    const main = root.querySelector('[data-rev-main]');
    const track = root.querySelector('[data-rev-track-main]');
    if (!main || !track) return;

    const slides = Array.from(track.querySelectorAll('.rev-media[data-index]'));
    if (!slides.length) return;

    const thumbsWrap = root.querySelector('.rev-gallery-thumbnails');
    const thumbs = Array.from(root.querySelectorAll('.rev-gallery-thumbnail-item[data-index]'));
    const bullets = Array.from(root.querySelectorAll('.rev-gallery-slide-bullet[data-index]'));
    const btnPrev = root.querySelector('.rev-gallery-button-prev');
    const btnNext = root.querySelector('.rev-gallery-button-next');

    const thumbByIndex = new Map();
    thumbs.forEach(t => thumbByIndex.set(Number(t.dataset.index), t));

    root.dataset.revGalleryInit = '1';
    root._revGalleryInstance = { setActive, scrollToIndex };

    let index = 0;
    let prevIndex = 0;

    let isProgrammaticScroll = false;
    let progTimer = null;

    function lockProgrammaticScroll(ms = 350) {
      isProgrammaticScroll = true;
      window.clearTimeout(progTimer);
      progTimer = window.setTimeout(() => { isProgrammaticScroll = false; }, ms);
    }

    function setActive(i, { thumbBehavior = 'smooth' } = {}) {
      prevIndex = index;
      index = clamp(i, 0, slides.length - 1);

      if (prevIndex !== index) resetVideoInSlide(slides[prevIndex]);

      setActiveUI({ thumbs, bullets, index });

      if (thumbsWrap && thumbs.length && isDesktop() && thumbsWrap.classList.contains('is-ready')) {
        scrollThumbToIndex({ thumbsWrap, thumbByIndex, index, behavior: thumbBehavior });
      }

      if (typeof startAutoswipe === 'function') {
        startAutoswipe();
      }
    }

    function scrollToIndex(i, behavior = 'smooth') {
      const next = clamp(i, 0, slides.length - 1);
      const target = slides[next];
      if (!target) return;
      lockProgrammaticScroll(behavior === 'smooth' ? 450 : 50);
      main.scrollTo({ left: target.offsetLeft, behavior });
      setActive(next, { thumbBehavior: 'auto' });
    }

    // ================================
    // AUTOSWIPE
    // ================================
    const autoplayRaw = root.getAttribute('data-autoplay');
    const autoswipeEnabled = autoplayRaw != null;
    const autoswipeSeconds = autoswipeEnabled
      ? clamp(parseInt(autoplayRaw, 10) || 0, 2, 14)
      : 0;

    const isSliderMode = () =>
      isDesktop() ? root.classList.contains('rev-product-gallery-slider') : true;

    let autoTimer = null;
    let autoRaf = null;
    let autoStartTs = 0;
    let autoPaused = false;

    function setProgress(p) {
      const clamped = Math.min(1, Math.max(0, p));
      root.style.setProperty('--rev-autoswipe-progress', clamped);
    }

    function clearAutoswipe() {
      clearTimeout(autoTimer);
      cancelAnimationFrame(autoRaf);
      autoTimer = null;
      autoRaf = null;
      setProgress(0);
    }

    function pauseAutoswipe(delay = 2500) {
      if (!autoswipeEnabled) return;
      autoPaused = true;
      root.classList.remove('is-autoswiping');
      clearAutoswipe();

      setTimeout(() => {
        autoPaused = false;
        startAutoswipe();
      }, delay);
    }

    function waitForVideo(slide) {
      return new Promise(resolve => {
        const video = slide?.querySelector('video');
        if (!video) return resolve();
        if (video.paused || video.ended) return resolve();

        const done = () => {
          video.removeEventListener('ended', done);
          video.removeEventListener('pause', done);
          resolve();
        };

        video.addEventListener('ended', done, { once: true });
        video.addEventListener('pause', done, { once: true });
      });
    }

    function tickProgress() {
      const elapsed = performance.now() - autoStartTs;
      setProgress(elapsed / (autoswipeSeconds * 1000));
      autoRaf = requestAnimationFrame(tickProgress);
    }

    async function advanceSlide() {
      await waitForVideo(slides[index]);
      if (autoPaused) return;

      scrollToIndex((index + 1) % slides.length, 'smooth');
      startAutoswipe();
    }

    function startAutoswipe() {
      if (
        !autoswipeEnabled ||
        !isSliderMode() ||
        autoPaused ||
        slides.length < 2 ||
        document.hidden
      ) {
        clearAutoswipe();
        root.classList.remove('is-autoswiping');
        return;
      }

      clearAutoswipe();
      root.classList.add('is-autoswiping');

      autoStartTs = performance.now();
      autoRaf = requestAnimationFrame(tickProgress);
      autoTimer = setTimeout(advanceSlide, autoswipeSeconds * 1000);
    }

    if (autoswipeEnabled) {
      // Pause on user intent
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(evt => {
        root.addEventListener(evt, () => pauseAutoswipe(), { passive: true });
      });

      // Pause on navigation buttons
      [btnPrev, btnNext].forEach(btn => {
        btn && btn.addEventListener('click', () => pauseAutoswipe());
      });

      bullets.forEach(b => b.addEventListener('click', () => pauseAutoswipe()));
      thumbs.forEach(t => t.addEventListener('click', () => pauseAutoswipe()));

      document.addEventListener('visibilitychange', () => {
        document.hidden ? clearAutoswipe() : startAutoswipe();
      });

      window.addEventListener('resize', () => {
        clearTimeout(root._revAutoswipeResizeT);
        root._revAutoswipeResizeT = setTimeout(startAutoswipe, 150);
      });
    }

    if (autoswipeEnabled) {
      startAutoswipe();
    }

    thumbs.forEach(t => {
      t.addEventListener('click', () => scrollToIndex(Number(t.dataset.index), 'smooth'));
    });
    bullets.forEach(b => {
      b.addEventListener('click', () => scrollToIndex(Number(b.dataset.index), 'smooth'));
    });
    if (btnPrev) btnPrev.addEventListener('click', () => scrollToIndex(index - 1, 'smooth'));
    if (btnNext) btnNext.addEventListener('click', () => scrollToIndex(index + 1, 'smooth'));

    let raf = null;
    main.addEventListener('scroll', () => {
      if (isProgrammaticScroll) return;
      if (raf) return;

      raf = requestAnimationFrame(() => {
        raf = null;
        const best = nearestIndexByScrollLeft(main, slides);
        setActive(best, { thumbBehavior: 'smooth' });
      });
    }, { passive: true });

    const scheduleReveal = () => requestAnimationFrame(() => applyThumbsHeightAndReveal(root));

    if (thumbsWrap && isDesktop()) {
      thumbsWrap.classList.remove('is-ready');
      thumbsWrap.style.setProperty('--rev-thumbs-h', '0px');
    }

    scheduleReveal();
    window.setTimeout(scheduleReveal, 30);
    window.setTimeout(scheduleReveal, 120);
    window.setTimeout(scheduleReveal, 250);

    root.querySelectorAll('.rev-gallery-main img').forEach(img => {
      if (img.complete) return;
      img.addEventListener('load', scheduleReveal, { once: true });
      img.addEventListener('error', scheduleReveal, { once: true });
    });

    root.querySelectorAll('.rev-gallery-main video').forEach(v => {
      if (v.readyState >= 1) return;
      v.addEventListener('loadedmetadata', scheduleReveal, { once: true });
      v.addEventListener('loadeddata', scheduleReveal, { once: true });
    });

    if ('ResizeObserver' in window) {
      const mainViewport = root.querySelector('.rev-gallery-main[data-rev-main]');
      if (mainViewport) {
        const ro = new ResizeObserver(() => scheduleReveal());
        ro.observe(mainViewport);
      }
    } else {
      window.addEventListener('resize', scheduleReveal);
    }

    setActive(0, { thumbBehavior: 'auto' });
    requestAnimationFrame(() => {
      scrollToIndex(0, 'auto');
      scheduleReveal();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.rev-product-gallery').forEach(init);
  }

  function destroy(root) {
    if (!root) return;
    root.dataset.revGalleryInit = '0';
  }

  return { init, initAll, destroy };
})();

(function () {
  function boot(scope) {
    window.RevGallery?.initAll(scope || document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();

// Trigger Rerender On Variant Change
document.addEventListener('rev:variant:change', async (e) => {
  const variantId = e.detail?.variantId;
  if (!variantId) return;

  await RevRerender.rerender({
    contextEl: document,
    targets: ['.rev-product-gallery'],
    url: window.location.pathname,
    params: { variant: variantId },
    incomingScopeSelector: 'main'
  });

  window.RevGallery?.initAll(document);
});

// ================================
// Gallery Zoom Desktop
// ================================
window.RevGalleryZoom = window.RevGalleryZoom || (() => {
  const MAGNIFICATION = 2.5;
  const OVERLAY_SIZE = 40; // percentage of image
  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

  function syncPreviewAspectToImage(img, zoomPreview) {
    if (!img || !zoomPreview) return;

    const imgRect = img.getBoundingClientRect();
    if (!imgRect.width || !imgRect.height) return;

    const aspect = imgRect.width / imgRect.height;
    const previewRect = zoomPreview.getBoundingClientRect();
    if (!previewRect.width) return;
    const desiredHeight = Math.round(previewRect.width / aspect);

    zoomPreview.style.setProperty(
      '--rev-zoom-preview-h',
      `${desiredHeight}px`
    );
  }

  function init(root) {
    if (!root || !isDesktop()) return;

    const galleryRoot = root.querySelector('.rev-product-gallery');
    if (!galleryRoot || galleryRoot.dataset.revZoomInit === '1') return;

    const mainViewport = root.querySelector('.rev-gallery-main[data-rev-main]');
    const track = root.querySelector('[data-rev-track-main]');
    const zoomPreview = root.querySelector('.rev-gallery-zoom-preview');
    const zoomOverlay = root.querySelector('.rev-gallery-zoom-overlay');
    const zoomBox = root.querySelector('.rev-gallery-zoom-box');

    if (!mainViewport || !track || !zoomPreview || !zoomOverlay || !zoomBox) return;

    galleryRoot.dataset.revZoomInit = '1';

    const slides = Array.from(track.querySelectorAll('.rev-media[data-index]'));
    if (!slides.length) return;

    function getVisibleImage() {
      let bestIndex = 0;
      let bestDist = Infinity;

      for (let i = 0; i < slides.length; i++) {
        const dist = Math.abs(slides[i].offsetLeft - mainViewport.scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          bestIndex = i;
        }
      }

      const visibleSlide = slides[bestIndex];
      if (!visibleSlide) return null;

      const img = visibleSlide.querySelector('img');
      const video = visibleSlide.querySelector('video');
      return img || video;
    }

    function getImageUrl(img) {
      if (!img) return null;
      return img.src || img.currentSrc || null;
    }

    mainViewport.addEventListener('mousemove', (e) => {
      const img = getVisibleImage();
      if (!img) return;

      const imgUrl = getImageUrl(img);
      if (!imgUrl) return;

      syncPreviewAspectToImage(img, zoomPreview);
      const imgRect = img.getBoundingClientRect();
      if (
        e.clientX < imgRect.left || e.clientX > imgRect.right ||
        e.clientY < imgRect.top || e.clientY > imgRect.bottom
      ) {
        zoomPreview.style.display = 'none';
        zoomOverlay.style.display = 'none';
        return;
      }

      const x = e.clientX - imgRect.left;
      const y = e.clientY - imgRect.top;
      const xPercent = (x / imgRect.width) * 100;
      const yPercent = (y / imgRect.height) * 100;
      const overlayLeft = Math.max(
        0,
        Math.min(100 - OVERLAY_SIZE, xPercent - OVERLAY_SIZE / 2)
      );
      const overlayTop = Math.max(
        0,
        Math.min(100 - OVERLAY_SIZE, yPercent - OVERLAY_SIZE / 2)
      );

      zoomPreview.style.display = 'block';
      zoomOverlay.style.display = 'block';

      zoomOverlay.style.left = overlayLeft + '%';
      zoomOverlay.style.top = overlayTop + '%';
      zoomOverlay.style.width = OVERLAY_SIZE + '%';
      zoomOverlay.style.height = OVERLAY_SIZE + '%';

      const magnification = 100 / OVERLAY_SIZE;

      const bgX = (overlayLeft / (100 - OVERLAY_SIZE)) * 100;
      const bgY = (overlayTop / (100 - OVERLAY_SIZE)) * 100;

      zoomBox.style.backgroundImage = `url('${imgUrl}')`;
      zoomBox.style.backgroundSize = `${magnification * 100}% ${magnification * 100}%`;
      zoomBox.style.backgroundPosition = `${bgX}% ${bgY}%`;
    });

    mainViewport.addEventListener('mouseleave', () => {
      zoomPreview.style.display = 'none';
      zoomOverlay.style.display = 'none';
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.rev-product-gallery').forEach(gallery => {
      const wrapper = gallery.closest('.rev-product-gallery-wrapper') || gallery.closest('[data-section-id]') || gallery.parentElement;
      if (wrapper) init(wrapper);
    });
  }

  return { init, initAll };
})();

(function () {
  function boot(scope) {
    window.RevGalleryZoom?.initAll(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();

// ================================
// Gallery Zoom Modal Scroll Lock
// ================================
(function () {
  function initScrollLock() {
    const zoomModals = document.querySelectorAll('.rev-gallery-zoom-modal');

    zoomModals.forEach(modal => {
      if (modal.dataset.scrollLockInit === '1') return;
      modal.dataset.scrollLockInit = '1';

      let scrollY = 0;

      // When popover opens
      modal.addEventListener('toggle', (e) => {
        if (e.newState === 'open') {
          // Store current scroll position
          scrollY = window.scrollY;

          // Lock body scroll
          document.body.style.position = 'fixed';
          document.body.style.top = `-${scrollY}px`;
          document.body.style.width = '100%';
          document.body.style.overflow = 'hidden';

          // Ensure modal content can scroll
          const content = modal.querySelector('.rev-gallery-zoom-content');
          if (content) {
            content.style.overflowY = 'auto';
            content.style.webkitOverflowScrolling = 'touch';
            content.style.overscrollBehavior = 'contain';
          }
        } else if (e.newState === 'closed') {
          // Restore body scroll
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';

          // Restore scroll position
          window.scrollTo(0, scrollY);
        }
      });

      // Prevent touch events from bubbling to body when touching modal content
      const content = modal.querySelector('.rev-gallery-zoom-content');
      if (content) {
        let startY = 0;

        content.addEventListener('touchstart', (e) => {
          startY = e.touches[0].clientY;
        }, { passive: true });

        content.addEventListener('touchmove', (e) => {
          const currentY = e.touches[0].clientY;
          const isScrollingUp = currentY > startY;
          const isScrollingDown = currentY < startY;
          const isAtTop = content.scrollTop === 0;
          const isAtBottom = content.scrollHeight - content.scrollTop === content.clientHeight;

          // Only prevent default if we're at scroll boundaries
          // This prevents the bounce/overscroll from affecting the body
          if ((isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown)) {
            e.preventDefault();
          }
        }, { passive: false });
      }
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollLock);
  } else {
    initScrollLock();
  }

  // Re-initialize when sections are loaded
  document.addEventListener('shopify:section:load', initScrollLock);
})();

// ================================
// Mini Slider
// ================================
window.RevMiniSlider = window.RevMiniSlider || (() => {
  const instances = new WeakMap();

  function setActiveBullet(bullets, index) {
    bullets.forEach((b, i) => b.classList.toggle('active', i === index));
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function init(root) {
    if (!root) return;
    if (instances.has(root)) return;

    const track = root.querySelector('[data-rev-mini-slider-track]');
    const pagination = root.querySelector('[data-rev-mini-slider-pagination]');
    if (!track || !pagination) return;

    const slides = Array.from(track.children).filter(el => el.classList.contains('rev-mini-slide'));
    const bullets = Array.from(pagination.querySelectorAll('[data-rev-mini-slider-bullet]'));

    const total = slides.length;

    const inst = { stop: () => { }, start: () => { }, goTo: () => { } };
    instances.set(root, inst);

    if (total <= 1) {
      if (bullets.length) setActiveBullet(bullets, 0);
      return;
    }

    const speedSecRaw = track.dataset.revMiniSliderSpeed;
    const speedSec = clamp(Number(speedSecRaw) || 2.5, 0.5, 60);
    const intervalMs = Math.round(speedSec * 1000);

    let index = 0;
    let timer = null;

    function goTo(i, { behavior = 'smooth' } = {}) {
      index = (i + total) % total;
      track.scrollTo({ left: track.clientWidth * index, behavior });

      if (bullets.length) setActiveBullet(bullets, index);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      timer = window.setInterval(() => goTo(index + 1, { behavior: 'smooth' }), intervalMs);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    bullets.forEach((b, i) => {
      b.addEventListener('click', () => {
        goTo(i, { behavior: 'smooth' });
        start();
      });
    });

    let raf = null;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;

        const w = track.clientWidth || 1;
        const next = clamp(Math.round(track.scrollLeft / w), 0, total - 1);

        if (next !== index) {
          index = next;
          if (bullets.length) setActiveBullet(bullets, index);
        }
      });
    }, { passive: true });

    inst.stop = stop;
    inst.start = start;
    inst.goTo = goTo;

    if (bullets.length) setActiveBullet(bullets, 0);
    goTo(0, { behavior: 'auto' });
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rev-mini-slider]').forEach(init);
  }

  function destroy(root) {
    const inst = instances.get(root);
    if (!inst) return;
    try { inst.stop?.(); } catch (_) { }
    instances.delete(root);
  }

  return { init, initAll, destroy };
})();

(function () {
  function boot(scope) {
    window.RevMiniSlider?.initAll(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();

// ================================
// Popularity Messaging
// ================================
(function () {
  if (window.__REV_POPULARITY__) return;
  window.__REV_POPULARITY__ = true;

  const inited = new Set();

  function clampInt(n, fallback) {
    const x = parseInt(n, 10);
    return Number.isFinite(x) ? x : fallback;
  }

  function randInt(min, max) {
    const a = Math.min(min, max);
    const b = Math.max(min, max);
    return Math.floor(Math.random() * (b - a + 1)) + a;
  }

  function initOne(el) {
    if (!el) return;

    const id = el.getAttribute('data-rev-pop-id') || '';

    if (id && inited.has(id)) return;
    if (id) inited.add(id);

    const min = clampInt(el.dataset.revPopMin, 20);
    const max = clampInt(el.dataset.revPopMax, 50);

    const numEl = el.querySelector('[data-rev-pop-number]');
    if (numEl) numEl.textContent = randInt(min, max);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rev-pop]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();

// ================================
// RevTimer (Universal, Lean, Configurable)
// - Supports multiple timers per page (instance-scoped)
// - Safe with Shopify section re-renders + DOM injections
// - Modes: fixed end OR evergreen duration (localStorage)
// - Formats: mmss | dhms | auto
// - Hide controls (schema-friendly CSV):
//    data-rev-timer-hide="days,hours"        -> always hide these units
//    data-rev-timer-hide-zero="days,hours"   -> hide these units when value is 0
//    data-rev-timer-collapse="true"          -> hide leading zero units (days->hours->mins)
// ================================
window.RevTimer = window.RevTimer || (() => {
  const instances = new WeakMap();

  const pad2 = (n) => String(n).padStart(2, '0');

  function getVisitorTimeZone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch (_) {
      return 'UTC';
    }
  }

  function getZonedParts(date, timeZone) {
    const dtf = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    const parts = dtf.formatToParts(date);
    const out = {};
    for (const p of parts) {
      if (p.type === 'year') out.year = Number(p.value);
      if (p.type === 'month') out.month = Number(p.value);
      if (p.type === 'day') out.day = Number(p.value);
      if (p.type === 'hour') out.hour = Number(p.value);
      if (p.type === 'minute') out.minute = Number(p.value);
      if (p.type === 'second') out.second = Number(p.value);
    }
    return out;
  }

  // Convert "YYYY-MM-DD" + "HH:MM:SS" interpreted in `timeZone` into UTC ms.
  // Handles DST by refining the offset once.
  function zonedWallTimeToUtcMs({ year, month, day, hour, minute, second }, timeZone) {
    // initial guess: treat wall time as UTC
    let guess = Date.UTC(year, month - 1, day, hour, minute, second);

    // find offset between guessed instant and desired zone wall time
    const p1 = getZonedParts(new Date(guess), timeZone);
    const asUtc1 = Date.UTC(p1.year, p1.month - 1, p1.day, p1.hour, p1.minute, p1.second);
    const offset1 = asUtc1 - guess;

    let corrected = Date.UTC(year, month - 1, day, hour, minute, second) - offset1;

    // refine once more for DST boundaries
    const p2 = getZonedParts(new Date(corrected), timeZone);
    const asUtc2 = Date.UTC(p2.year, p2.month - 1, p2.day, p2.hour, p2.minute, p2.second);
    const offset2 = asUtc2 - corrected;

    corrected = Date.UTC(year, month - 1, day, hour, minute, second) - offset2;
    return corrected;
  }

  function parseDateTimeFields(el) {
    const d = (el.getAttribute('data-rev-timer-end-date') || '').trim(); // YYYY-MM-DD
    const t = (el.getAttribute('data-rev-timer-end-time') || '').trim(); // HH:MM:SS
    if (!d || !t) return null;

    const mD = d.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const mT = t.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!mD || !mT) return null;

    return {
      year: Number(mD[1]),
      month: Number(mD[2]),
      day: Number(mD[3]),
      hour: Number(mT[1]),
      minute: Number(mT[2]),
      second: Number(mT[3] || '0')
    };
  }

  function boolAttr(el, name, fallback = false) {
    const v = el.getAttribute(name);
    if (v == null) return fallback;
    return v === '' || v === 'true' || v === '1';
  }

  function parseCsvSet(el, name) {
    const raw = (el.getAttribute(name) || '').trim().toLowerCase();
    if (!raw) return new Set();
    return new Set(
      raw.split(',')
        .map(s => s.trim())
        .filter(Boolean)
    );
  }

  function parseEndMs(el) {
    // 1) Preferred: date + time + tz
    const fields = parseDateTimeFields(el);
    if (fields) {
      let tz = (el.getAttribute('data-rev-timer-tz') || '').trim();
      if (!tz) tz = 'UTC';
      if (tz === 'visitor') tz = getVisitorTimeZone();

      try {
        return zonedWallTimeToUtcMs(fields, tz);
      } catch (_) {
        // fall back to ISO parsing below
      }
    }

    // 2) Back-compat: ISO / epoch ms in data-rev-timer-end
    const raw = (el.getAttribute('data-rev-timer-end') || '').trim();
    if (!raw) return null;
    if (/^\d{10,}$/.test(raw)) return Number(raw); // epoch ms
    const t = Date.parse(raw);
    return Number.isFinite(t) ? t : null;
  }

  function getEvergreenEndMs(el) {
    const durSec = parseInt(el.getAttribute('data-rev-timer-duration') || '', 10);
    if (!durSec) return null;

    const key = (el.getAttribute('data-rev-timer-key') || '').trim() || el.id || null;

    // No key => works for this page load only (no persistence)
    if (!key) return Date.now() + (durSec * 1000);

    const storageKey = `revTimer_${key}`;
    let end = parseInt(localStorage.getItem(storageKey) || '', 10);

    if (!end || end < Date.now()) {
      end = Date.now() + (durSec * 1000);
      try { localStorage.setItem(storageKey, String(end)); } catch (_) { }
    }

    return end;
  }

  function split(msLeft) {
    const total = Math.max(0, Math.floor(msLeft / 1000));
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const mins = Math.floor((total % 3600) / 60);
    const secs = total % 60;
    return { total, days, hours, mins, secs };
  }

  function formatMmss(parts, pad) {
    const minutesTotal = Math.floor(parts.total / 60); // rolls up days/hours into minutes
    const mm = pad ? pad2(minutesTotal) : String(minutesTotal);
    const ss = pad ? pad2(parts.secs) : String(parts.secs);
    return `${mm}:${ss}`;
  }

  // Single-string DHMS formatter that respects hide/hide-zero/collapse.
  // Guarantees something sensible is shown even if some units are hidden.
  function formatDhms(parts, pad, cfg) {
    const hardHide = cfg.hideSet;
    const hideZero = cfg.hideZeroSet;
    const collapse = cfg.collapse;

    const unitVals = {
      days: parts.days,
      hours: parts.hours,
      mins: parts.mins,
      secs: parts.secs
    };

    function shouldHide(unit) {
      if (hardHide.has(unit)) return true;
      if (hideZero.has(unit) && unitVals[unit] === 0) return true;

      if (collapse) {
        if (unit === 'days') return unitVals.days === 0;
        if (unit === 'hours') return unitVals.days === 0 && unitVals.hours === 0;
        if (unit === 'mins') return unitVals.days === 0 && unitVals.hours === 0 && unitVals.mins === 0;
        // secs never collapsed by default
      }

      return false;
    }

    const d = shouldHide('days') ? null : `${unitVals.days}d`;
    const h = shouldHide('hours') ? null : `${pad ? pad2(unitVals.hours) : unitVals.hours}h`;
    const m = shouldHide('mins') ? null : `${pad ? pad2(unitVals.mins) : unitVals.mins}m`;
    const s = shouldHide('secs') ? null : `${pad ? pad2(unitVals.secs) : unitVals.secs}s`;

    // Ensure at least one unit shows
    const partsOut = [d, h, m, s].filter(Boolean);
    if (partsOut.length) return partsOut.join(' ');

    // If everything got hidden, fall back to MM:SS style seconds
    const mm = pad ? pad2(Math.floor(parts.total / 60)) : String(Math.floor(parts.total / 60));
    const ss = pad ? pad2(parts.secs) : String(parts.secs);
    return `${mm}:${ss}`;
  }

  function applySplitVisibility(root, parts, cfg, formatMode) {
    // Optional wrappers for clean hiding:
    // <span data-rev-timer-unit="days">...</span>
    const wrap = (unit) => root.querySelector(`[data-rev-timer-unit="${unit}"]`);

    const wDays = wrap('days');
    const wHours = wrap('hours');
    const wMins = wrap('mins');
    const wSecs = wrap('secs');

    const hardHide = cfg.hideSet;
    const hideZero = cfg.hideZeroSet;
    const collapse = cfg.collapse;

    // In mmss mode, days/hours are almost always unwanted; recommend leaving them out of markup.
    // But if they exist, we’ll still honor rules.
    const val = {
      days: parts.days,
      hours: parts.hours,
      mins: parts.mins,
      secs: parts.secs
    };

    function shouldHide(unit) {
      if (hardHide.has(unit)) return true;

      // per-unit hide-when-zero (independent; can look odd if you hide hours while days show)
      if (hideZero.has(unit) && val[unit] === 0) return true;

      if (collapse) {
        if (unit === 'days') return val.days === 0;
        if (unit === 'hours') return val.days === 0 && val.hours === 0;
        if (unit === 'mins') return val.days === 0 && val.hours === 0 && val.mins === 0;
      }

      // extra: if format is mmss, hide day/hour wrappers unless user explicitly keeps them
      if (formatMode === 'mmss' && (unit === 'days' || unit === 'hours')) {
        return true;
      }

      return false;
    }

    if (wDays) wDays.style.display = shouldHide('days') ? 'none' : '';
    if (wHours) wHours.style.display = shouldHide('hours') ? 'none' : '';
    if (wMins) wMins.style.display = shouldHide('mins') ? 'none' : '';
    if (wSecs) wSecs.style.display = shouldHide('secs') ? 'none' : '';
  }

  function initOne(el) {
    if (!el || el.nodeType !== 1) return;
    if (instances.has(el)) return;
    const shouldSync = boolAttr(el, 'data-rev-timer-sync', false);
    if (shouldSync) {
      const primaryTimer = Array.from(document.querySelectorAll('[data-rev-timer]'))
        .find(timer => timer !== el && !boolAttr(timer, 'data-rev-timer-sync', false));
      if (primaryTimer && instances.has(primaryTimer)) {
        const primaryData = instances.get(primaryTimer);
        const attrsToCopy = [
          'data-rev-timer-end-date',
          'data-rev-timer-end-time',
          'data-rev-timer-tz',
          'data-rev-timer-duration',
          'data-rev-timer-key',
          'data-rev-timer-format',
          'data-rev-timer-pad',
          'data-rev-timer-collapse',
          'data-rev-timer-hide',
          'data-rev-timer-hide-zero'
        ];
        attrsToCopy.forEach(attr => {
          const val = primaryTimer.getAttribute(attr);
          if (val !== null) {
            el.setAttribute(attr, val);
          }
        });
        if (primaryData.endMs) {
          el._syncedEndMs = primaryData.endMs;
        }
      }
    }
    const out = el.querySelector('[data-rev-timer-out]');
    const ddEl = el.querySelector('[data-rev-timer-dd]');
    const hhEl = el.querySelector('[data-rev-timer-hh]');
    const mmEl = el.querySelector('[data-rev-timer-mm]');
    const ssEl = el.querySelector('[data-rev-timer-ss]');
    const hasSplit = !!(ddEl || hhEl || mmEl || ssEl);
    const formatMode = (el.getAttribute('data-rev-timer-format') || 'auto').trim().toLowerCase();
    const pad = boolAttr(el, 'data-rev-timer-pad', true);
    const cfg = {
      collapse: boolAttr(el, 'data-rev-timer-collapse', false),
      hideSet: parseCsvSet(el, 'data-rev-timer-hide'),
      hideZeroSet: parseCsvSet(el, 'data-rev-timer-hide-zero'),
      expiredText: (el.getAttribute('data-rev-timer-expired-text') || 'Expired').trim(),
      hideExpired: boolAttr(el, 'data-rev-timer-hide-expired', false),
    };
    let endMs = el._syncedEndMs || parseEndMs(el);
    if (!endMs) endMs = getEvergreenEndMs(el);
    if (!endMs) return;
    let lastSec = null;
    function stop() {
      clearInterval(id);
    }
    function render(parts) {
      // Split-field mode
      if (hasSplit) {
        if (formatMode === 'mmss') {
          const minutesTotal = Math.floor(parts.total / 60);
          if (mmEl) mmEl.textContent = pad ? pad2(minutesTotal) : String(minutesTotal);
          if (ssEl) ssEl.textContent = pad ? pad2(parts.secs) : String(parts.secs);
          if (ddEl) ddEl.textContent = String(parts.days);
          if (hhEl) hhEl.textContent = pad ? pad2(parts.hours) : String(parts.hours);
          applySplitVisibility(el, parts, cfg, 'mmss');
          return;
        }
        if (ddEl) ddEl.textContent = String(parts.days);
        if (hhEl) hhEl.textContent = pad ? pad2(parts.hours) : String(parts.hours);
        if (mmEl) mmEl.textContent = pad ? pad2(parts.mins) : String(parts.mins);
        if (ssEl) ssEl.textContent = pad ? pad2(parts.secs) : String(parts.secs);
        applySplitVisibility(el, parts, cfg, formatMode);
        return;
      }
      // Single output
      if (out) {
        if (formatMode === 'mmss') out.textContent = formatMmss(parts, pad);
        else if (formatMode === 'dhms') out.textContent = formatDhms(parts, pad, cfg);
        else out.textContent = formatDhms(parts, pad, cfg);
      }
    }
    function tick() {
      if (!document.contains(el)) return stop();
      const msLeft = endMs - Date.now();
      if (msLeft <= 0) {
        if (cfg.hideExpired) el.style.display = 'none';
        else {
          if (out) out.textContent = cfg.expiredText;
        }
        el.dispatchEvent(new CustomEvent('rev:timer:expired', { bubbles: true }));
        return stop();
      }
      const parts = split(msLeft);
      const sec = parts.total;
      if (sec === lastSec) return;
      lastSec = sec;
      render(parts);
    }
    const id = setInterval(tick, 250);
    instances.set(el, { stop, endMs }); // NEW: Store endMs for syncing
    tick();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rev-timer]').forEach(initOne);
  }

  function boot() {
    initAll(document);

    document.addEventListener('shopify:section:load', (e) => initAll(e.target));

    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes || []) {
          if (n.nodeType !== 1) continue;
          if (n.matches?.('[data-rev-timer]')) initOne(n);
          n.querySelectorAll?.('[data-rev-timer]').forEach(initOne);
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
    window.__REV_TIMER_OBSERVER__ = mo; // optional debug
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  return { initAll };
})();

// ================================
// Card Slider
// ================================
const RevCardSlider = {
  init() {
    document.querySelectorAll('[data-rev-card-slider-container]:not([data-rev-card-slider-init])').forEach(container => {
      this.setupSlider(container);
      container.setAttribute('data-rev-card-slider-init', 'true');
    });
  },
  setupSlider(container) {
    const wrap = container.querySelector('[data-rev-card-slider]');
    const track = container.querySelector('[data-rev-card-slider-track]');
    const prevBtn = container.querySelector('.rev-card-slider-prev');
    const nextBtn = container.querySelector('.rev-card-slider-next');
    const indicatorContainer = container.querySelector('[data-rev-card-slider-indicator]');
    const items = track.querySelectorAll('.rev-card-slider__item');
    if (!items.length) return;
    let currentIndex = 0;
    let isScrolling = false;
    const totalItems = items.length;
    // Generate bullets based on visible count
    const generateBullets = () => {
      if (!indicatorContainer) return;
      const visibleCount = this.getVisibleCount(track, items);
      const pageCount = Math.ceil(totalItems / visibleCount);
      // Clear existing bullets
      indicatorContainer.innerHTML = '';
      // Create new bullets
      for (let i = 0; i < pageCount; i++) {
        const bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'rev-card-slider-bullet' + (i === 0 ? ' rev-card-slider-bullet-active' : '');
        bullet.dataset.index = i;
        bullet.setAttribute('aria-label', `Go to page ${i + 1}`);
        bullet.addEventListener('click', () => scrollToPage(i));
        indicatorContainer.appendChild(bullet);
      }
    };
    const getPageIndex = () => {
      const visibleCount = this.getVisibleCount(track, items);
      return Math.floor(currentIndex / visibleCount);
    };
    const updateBullets = () => {
      if (!indicatorContainer) return;
      const bullets = indicatorContainer.querySelectorAll('.rev-card-slider-bullet');
      const visibleCount = this.getVisibleCount(track, items);
      const maxIndex = totalItems - visibleCount;
      let pageIndex;
      // If we're at or past the max scroll position, show last bullet
      if (currentIndex >= maxIndex) {
        pageIndex = bullets.length - 1;
      } else {
        pageIndex = Math.floor(currentIndex / visibleCount);
      }
      bullets.forEach((bullet, index) => {
        bullet.classList.toggle('rev-card-slider-bullet-active', index === pageIndex);
      });
    };
    const updateButtons = () => {
      const visibleCount = this.getVisibleCount(track, items);
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= totalItems - visibleCount;
    };
    const scrollToIndex = (index) => {
      const item = items[index];
      if (!item) return;
      isScrolling = true;
      wrap.scrollTo({
        left: item.offsetLeft,
        behavior: 'smooth'
      });
      currentIndex = index;
      updateButtons();
      updateBullets();
      setTimeout(() => {
        isScrolling = false;
      }, 350);
    };
    const scrollToPage = (pageIndex) => {
      const visibleCount = this.getVisibleCount(track, items);
      const targetIndex = Math.min(pageIndex * visibleCount, totalItems - visibleCount);
      scrollToIndex(Math.max(0, targetIndex));
    };
    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const visibleCount = this.getVisibleCount(track, items);
        const currentPage = currentIndex >= (totalItems - visibleCount)
          ? Math.ceil(totalItems / visibleCount) - 1
          : Math.floor(currentIndex / visibleCount);
        const targetPage = Math.max(0, currentPage - 1);
        const targetIndex = targetPage * visibleCount;
        scrollToIndex(targetIndex);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const visibleCount = this.getVisibleCount(track, items);
        const currentPage = currentIndex >= (totalItems - visibleCount)
          ? Math.ceil(totalItems / visibleCount) - 1
          : Math.floor(currentIndex / visibleCount);
        const targetPage = currentPage + 1;
        const maxStartIndex = totalItems - visibleCount;
        const targetIndex = Math.min(targetPage * visibleCount, maxStartIndex);
        scrollToIndex(targetIndex);
      });
    }
    // Sync on scroll
    wrap.addEventListener('scroll', () => {
      if (isScrolling) return;
      const scrollLeft = wrap.scrollLeft;
      const itemWidth = items[0].offsetWidth + parseInt(getComputedStyle(track).gap || 0);
      const newIndex = Math.round(scrollLeft / itemWidth);
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updateButtons();
        updateBullets();
      }
    });
    // Regenerate bullets on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        generateBullets();
        updateButtons();
      }, 150);
    });
    // Initial setup
    generateBullets();
    updateButtons();
  },
  getVisibleCount(track, items) {
    if (!items || !items.length) return 1;
    const trackWidth = track.offsetWidth;
    const itemWidth = items[0].offsetWidth;
    const gap = parseInt(getComputedStyle(track).gap || 0);
    return Math.max(1, Math.floor((trackWidth + gap) / (itemWidth + gap)));
  }
};
// Auto-init on DOM ready
document.addEventListener('DOMContentLoaded', () => RevCardSlider.init());

// ================================
// Product Form Sync
// Synchronizes variant and quantity selectors with form hidden inputs.
// Bridges the gap between UI controls (outside form) and form submission data (inside form).
// - Safe with Shopify section re-renders
// - Scoped to specific containers via data-product-form-sync attribute
// ================================
(function () {
  if (window.__REV_PRODUCT_FORM_SYNC__) return;
  window.__REV_PRODUCT_FORM_SYNC__ = true;

  const inited = new WeakSet();

  function initProductFormSync(el) {
    if (!el || el.nodeType !== 1) return;
    if (inited.has(el)) return;
    inited.add(el);

    const form = el.querySelector('form.rev-product-form');
    if (!form) return;

    // ----------------------------------------
    // VARIANT SELECTOR SYNCHRONIZATION
    // ----------------------------------------
    // Listens for 'change' events on the variant selector container.
    // Reads variant configuration from embedded .rev-cfg JSON script.
    // Collects current option values from radio buttons or select dropdowns.
    // Finds matching variant by comparing option1/option2/option3 values.
    // Updates the hidden input inside the form with the matched variant ID.
    // ----------------------------------------
    const variantSelector = el.querySelector('.rev-variant-selector');
    const variantHiddenInput = form.querySelector('[data-rev-variant-id]');

    if (variantSelector && variantHiddenInput) {
      variantSelector.addEventListener('change', function () {
        const cfgScript = variantSelector.querySelector('.rev-cfg');
        if (!cfgScript) return;

        let cfg;
        try {
          cfg = JSON.parse(cfgScript.textContent.trim());
        } catch (e) {
          return;
        }

        // Collect selected option values (supports both radio buttons and dropdowns)
        const selected = [];
        variantSelector.querySelectorAll('.rev-option').forEach(function (optionDiv, idx) {
          const checked = optionDiv.querySelector('input[type="radio"]:checked');
          const selectEl = optionDiv.querySelector('select');
          if (checked) {
            selected[idx] = checked.value;
          } else if (selectEl) {
            selected[idx] = selectEl.value;
          }
        });

        // Find the variant that matches all selected options
        const variant = cfg.variants.find(function (v) {
          return (v.option1 === selected[0] || !selected[0]) &&
            (v.option2 === selected[1] || !selected[1]) &&
            (v.option3 === selected[2] || !selected[2]);
        });

        // Update the hidden input that the form will submit
        if (variant && variant.id) {
          variantHiddenInput.value = variant.id;
        }
      });
    }

    // ----------------------------------------
    // QUANTITY SELECTOR SYNCHRONIZATION
    // ----------------------------------------
    // 1. Find the visible quantity input (number field) outside the form
    // 2. Initialize the hidden quantity input inside the form with current value
    // 3. Listen for both 'change' and 'input' events to catch all user interactions
    // 4. Copy the quantity value to the hidden input on every change
    //
    // The hidden input (data-rev-quantity) is what Shopify's cart API reads on form submit.
    // ----------------------------------------
    const qtySelector = el.querySelector('.rev-qty-selector');
    const qtyHiddenInput = form.querySelector('[data-rev-quantity]');

    if (qtySelector && qtyHiddenInput) {
      const qtyInput = qtySelector.querySelector('input[type="number"]');
      if (qtyInput) {
        // Initialize: ensure hidden input matches visible input on page load
        qtyHiddenInput.value = qtyInput.value || 1;

        // Sync on 'change': triggered by +/- buttons and when input loses focus
        qtyInput.addEventListener('change', function () {
          qtyHiddenInput.value = qtyInput.value || 1;
        });

        // Sync on 'input': triggered during typing for immediate feedback
        qtyInput.addEventListener('input', function () {
          qtyHiddenInput.value = qtyInput.value || 1;
        });
      }
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-form-sync]').forEach(initProductFormSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();

// ================================
// Video Review Carousel
// Section: rev-video-review-carousel
// Purpose: Infinite loop coverflow carousel with auto-advance on video end
// ================================

window.RevVideoCarousel = window.RevVideoCarousel || (() => {

  function init(root) {
    if (!root || root.dataset.revVideoCarouselInit === '1') return;

    const track = root.querySelector('[data-rev-video-carousel-track]');
    const originalSlides = Array.from(root.querySelectorAll('.rev-video-review-carousel__slide'));
    const prevBtn = root.querySelector('[data-rev-video-carousel-prev]');
    const nextBtn = root.querySelector('[data-rev-video-carousel-next]');

    if (!track || originalSlides.length === 0) return;

    root.dataset.revVideoCarouselInit = '1';

    let slides = [...originalSlides];
    let currentIndex = 0;
    let isAnimating = false;
    const slideCount = originalSlides.length;

    // Clone slides for infinite loop effect
    // We need enough clones so slides appear on both sides from the start
    if (slideCount >= 1) {
      const clonesNeeded = Math.max(3, Math.ceil(5 / slideCount));

      // Prepend clones (reversed order)
      for (let c = 0; c < clonesNeeded; c++) {
        [...originalSlides].reverse().forEach((slide, i) => {
          const clone = slide.cloneNode(true);
          clone.classList.add('is-clone');
          clone.classList.remove('is-active');
          clone.setAttribute('data-clone', 'prepend');
          clone.setAttribute('data-original-index', slideCount - 1 - i);
          track.insertBefore(clone, track.firstChild);
        });
      }

      // Append clones
      for (let c = 0; c < clonesNeeded; c++) {
        originalSlides.forEach((slide, i) => {
          const clone = slide.cloneNode(true);
          clone.classList.add('is-clone');
          clone.classList.remove('is-active');
          clone.setAttribute('data-clone', 'append');
          clone.setAttribute('data-original-index', i);
          track.appendChild(clone);
        });
      }

      // Update slides array
      slides = Array.from(track.querySelectorAll('.rev-video-review-carousel__slide'));

      // Start at the first real slide (after prepended clones)
      currentIndex = clonesNeeded * slideCount;
    }

    // Get slide width including margin
    function getSlideWidth() {
      const slide = slides[0];
      if (!slide) return 280;
      const style = getComputedStyle(slide);
      const width = slide.offsetWidth;
      const marginLeft = parseInt(style.marginLeft) || 0;
      const marginRight = parseInt(style.marginRight) || 0;
      return width + marginLeft + marginRight;
    }

    // Position track to center the current slide
    function positionTrack(animate = true) {
      const slideWidth = getSlideWidth();
      const trackWidth = root.offsetWidth;
      const centerOffset = (trackWidth / 2) - (slideWidth / 2);
      const targetX = -(currentIndex * slideWidth) + centerOffset;

      track.style.transition = animate ? 'transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)' : 'none';
      track.style.transform = `translateX(${targetX}px)`;
    }

    // Update slide classes
    function updateSlideClasses() {
      slides.forEach((slide, i) => {
        slide.classList.remove('is-active');
        if (i === currentIndex) {
          slide.classList.add('is-active');
        }
      });
    }

    // Handle video playback
    function handleVideoPlayback() {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;

        if (i === currentIndex) {
          // Play active video (muted by default)
          video.currentTime = 0;
          video.muted = true;
          slide.setAttribute('data-muted', 'true');
          video.play().catch(() => { });
        } else {
          // Pause non-active videos
          video.pause();
        }
      });
    }

    // Setup video end listeners for auto-advance
    function setupVideoEndListeners() {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;

        video.addEventListener('ended', () => {
          // Only advance if this slide is still active
          if (i === currentIndex) {
            next();
          }
        });
      });
    }

    // Go to specific index
    function goTo(index, animate = true) {
      if (isAnimating) return;

      currentIndex = index;
      updateSlideClasses();
      positionTrack(animate);
      handleVideoPlayback();

      if (animate) {
        isAnimating = true;

        setTimeout(() => {
          isAnimating = false;

          // Handle infinite loop wrap
          const clonesPerSide = (slides.length - slideCount) / 2;

          // If we've scrolled past the end clones, jump back to real slides
          if (currentIndex >= slides.length - clonesPerSide) {
            currentIndex = clonesPerSide + ((currentIndex - clonesPerSide) % slideCount);
            positionTrack(false);
            updateSlideClasses();
          }
          // If we've scrolled past the start clones, jump to end of real slides
          else if (currentIndex < clonesPerSide) {
            currentIndex = slides.length - clonesPerSide - (clonesPerSide - currentIndex);
            positionTrack(false);
            updateSlideClasses();
          }
        }, 520);
      }
    }

    // Next slide
    function next() {
      goTo(currentIndex + 1);
    }

    // Previous slide
    function prev() {
      goTo(currentIndex - 1);
    }

    // Volume toggle setup
    function setupVolumeToggles() {
      slides.forEach((slide) => {
        const volumeBtn = slide.querySelector('[data-rev-volume-toggle]');
        const video = slide.querySelector('video');

        if (!volumeBtn || !video) return;

        slide.setAttribute('data-muted', 'true');

        volumeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const isMuted = video.muted;
          video.muted = !isMuted;
          slide.setAttribute('data-muted', isMuted ? 'false' : 'true');
        });
      });
    }

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', prev);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', next);
    }

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          next();
        } else {
          prev();
        }
      }
    }, { passive: true });

    // Click on non-active slide to navigate
    slides.forEach((slide, i) => {
      slide.addEventListener('click', () => {
        if (i !== currentIndex && !slide.classList.contains('is-active')) {
          goTo(i);
        }
      });
    });

    // Pause on visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        slides.forEach(slide => {
          const video = slide.querySelector('video');
          if (video) video.pause();
        });
      } else {
        handleVideoPlayback();
      }
    });

    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        positionTrack(false);
      }, 100);
    });

    // Initialize
    setupVolumeToggles();
    setupVideoEndListeners();
    updateSlideClasses();

    // Position track after a brief delay to ensure CSS is applied
    requestAnimationFrame(() => {
      positionTrack(false);
      // Start playing the first video
      setTimeout(handleVideoPlayback, 100);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rev-video-carousel]').forEach(init);
  }

  // Auto-init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  // Shopify section load
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));

  return { init, initAll };
})();
